<template>
  <div class="ai rt60">
    <div>
      <!-- <banner :child-data="fdata"></banner> -->
      <div class="h650 mainTop"
           :style="{ height: Mobile + 'px'}">
        <img src="img/Solution/新零售-02_2.jpg"
             alt=""
             class="bg100 mobile">
        <div class="poA">
          <h3>{{$t('solution0_H0')}}</h3>
          <p>{{$t('solution0_P0')}}</p>
          <!-- <p>驻店时长,热点区域分析,员工在岗,远程巡店</p> -->
        </div>
      </div>
      <div class="ai-sec"
           style="
    position: relative;
">
        <el-tabs v-model="activeName"
                 @tab-click="handleClick">
          <el-tab-pane :label="$t('solution0_Label0')"
                       name="picture">
            <div id="ai-main">
              <transition name="plus-icon">
                <div v-if="activeName == 'picture'">
                  <div class="ai-advantage bcw pb0"
                       data-ani>
                    <div class="container h350">
                      <div class="develop-title">
                        <span class="line"></span>
                        <span class="title-text">{{$t('solution0_Label0')}}</span>
                        <span class="line"></span>
                      </div>
                      <div class="row">
                        <div class="col-xs-12 col-sm-6"
                             style="background-image:url(/static/img/babyOnline_intro.jpg);"><img src="img/Solution/客户画像.jpg"
                               alt=""
                               class="img-block"></div>
                        <div class="txtbox col-xs-12 col-sm-6 ">
                          <p style="text-align: left;">{{$t('solution0_Descript0')}}
                          </p>
                          <p style="text-align: left;"><strong>{{$t('solution0_DescriptH0')}}</strong></p>
                          <p style="text-align: left;">{{$t('solution0_DescriptP0')}}</p>
                          <p style="text-align: left;"><strong>{{$t('solution0_DescriptH1')}}</strong></p>
                          <p style="text-align: left;">{{$t('solution0_DescriptP1')}}</p>
                          <p style="text-align: left;"><strong>{{$t('solution0_DescriptH2')}}</strong></p>
                          <p style="text-align: left;">{{$t('solution0_DescriptP2')}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ai-advantage"
                       data-ani>
                    <div class="container">
                      <div class="develop-title">
                        <span class="line"></span>
                        <span class="title-text">{{$t('solution0_advantage')}}</span>
                        <span class="line"></span>
                      </div>
                      <div class="row">
                        <div class="col-sm-5"
                             style="padding-top:46px">
                          <div class="row row-10">
                            <div class="col-sm-6">
                              <div data-aos="fade-up"
                                   data-aos-delay="50"
                                   class="advantage-box aos-init aos-animate"><i class="iconfont icon-pcduan f70"></i>
                                <p class="p16">{{$t('solution0_advantage0')}}</p>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div data-aos="fade-up"
                                   data-aos-delay="100"
                                   class="advantage-box aos-init aos-animate"><span class="iconfont icon-tuichu f70"></span>
                                <p class="p16">{{$t('solution0_advantage1')}}</p>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div data-aos="fade-up"
                                   data-aos-delay="150"
                                   class="advantage-box aos-init aos-animate"><span class="iconfont icon-gouwuche1 f70"></span>
                                <p class="p16">{{$t('solution0_advantage2')}}</p>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div data-aos="fade-up"
                                   data-aos-delay="200"
                                   class="advantage-box aos-init aos-animate"><span class="iconfont icon-pcduan f70"></span>
                                <p class="p16">{{$t('solution0_advantage3')}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-7">
                          <div data-aos="zoom-in"
                               data-aos-delay="100"
                               class="advantage-show aos-init aos-animate animated infinite upDown">
                            <ul>
                              <li data-aos="zoom-in"
                                  data-aos-delay="150"
                                  class="aos-init one aos-animate animated infinite upDown"
                                  style="background-image:url(img/Solution/safeVillage_a_1.jpg);">
                                <p data-aos="zoom-in"
                                   data-aos-delay="500"
                                   class="aos-init aos-animate"><span class="iconfont icon-tag"></span>{{$t('solution0_advantage0')}}</p>
                              </li>
                              <li data-aos="zoom-in"
                                  data-aos-delay="200"
                                  class="aos-init two aos-animate animated infinite upDown"
                                  style="background-image:url(img/Solution/safeVillage_a_2.jpg);">
                                <p data-aos="zoom-in"
                                   data-aos-delay="500"
                                   class="aos-init aos-animate"><span class="iconfont icon-tag"></span>{{$t('solution0_advantage2')}}</p>
                              </li>
                              <li data-aos="zoom-in"
                                  data-aos-delay="250"
                                  class="aos-init three aos-animate animated infinite upDown"
                                  style="background-image:url(img/Solution/safeVillage_a_3.jpg);">
                                <p data-aos="zoom-in"
                                   data-aos-delay="500"
                                   class="aos-init aos-animate"><span class="iconfont icon-tag"></span>{{$t('solution0_advantage3')}}</p>
                              </li>
                              <li data-aos="zoom-in"
                                  data-aos-delay="300"
                                  class="aos-init four aos-animate animated infinite upDown"
                                  style="background-image:url(img/Solution/safeVillage_a_4.jpg);">
                              </li>
                              <li data-aos="zoom-in"
                                  data-aos-delay="350"
                                  class="aos-init five aos-animate animated infinite upDown"
                                  style="background-image:url(img/Solution/safeVillage_a_5.jpg);">
                                <p data-aos="zoom-in"
                                   data-aos-delay="500"
                                   class="aos-init aos-animate"><span class="iconfont icon-tag"></span>{{$t('solution0_advantage1')}}</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ai-advantage bcw"
                       data-ani>
                    <div class="container">
                      <div class="develop-title">
                        <span class="line"></span>
                        <span class="title-text">{{$t('solution0_function')}}</span>
                        <span class="line"></span>
                      </div>
                      <div class="solutionDitails">
                        <b-card-group deck>
                          <b-card>
                            <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/热力分布.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poL">
                                <h3>{{$t('solution0_function0')}}</h3>
                              </div>
                            </div>
                          </b-card>
                          <b-card>
                            <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/人脸特征.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poL">
                                <h3>{{$t('solution0_function1')}}</h3>
                              </div>
                            </div>
                          </b-card>
                          <b-card>
                            <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/职业特征.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poL">
                                <h3>{{$t('solution0_function2')}}</h3>
                              </div>
                            </div>
                          </b-card>
                        </b-card-group>

                        <!-- <b-card-group deck>
                          <b-card>
                            <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/a-06.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poR">
                                <h3>{{$t('solution0_function3')}}</h3>
                              </div>
                            </div>
                          </b-card>
                          <b-card>
                            <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/a-07.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poL">
                                <h3>{{$t('solution0_function4')}}</h3>
                              </div>
                            </div>
                          </b-card>
                          <b-card>
                            <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/a-08.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poR">
                                <h3>{{$t('solution0_function5')}}</h3>
                              </div>
                            </div>
                          </b-card>
                        </b-card-group> -->
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('solution0_Label1')"
                       name="store">
            <div id="ai-main">
              <transition name="plus-icon">
                <div v-if="activeName == 'store'">
                  <div class="ai-advantage bcw pb0"
                       data-ani>
                    <div class="container h350">
                      <div class="develop-title">
                        <span class="line"></span>
                        <span class="title-text">{{$t('solution0_Label1')}}</span>
                        <span class="line"></span>
                      </div>
                      <div class="row">
                        <div class="col-xs-12 col-sm-6"
                             style="background-image:url(/static/img/babyOnline_intro.jpg);"><img src="img/Solution/远程巡店.jpg"
                               alt=""
                               class="img-block"></div>
                        <div class="txtbox col-xs-12 col-sm-6 ">
                          <p style="text-align: left;">{{$t('solution0_Descript1')}}
                          </p>
                          <p style="text-align: left;"><strong>{{$t('solution0_DescriptH00')}}</strong></p>
                          <p style="text-align: left;">{{$t('solution0_DescriptP00')}}</p>
                          <p style="text-align: left;"><strong>{{$t('solution0_DescriptH01')}}</strong></p>
                          <p style="text-align: left;">{{$t('solution0_DescriptP01')}}</p>
                          <p style="text-align: left;"><strong>{{$t('solution0_DescriptH01')}}</strong></p>
                          <p style="text-align: left;">{{$t('solution0_DescriptP01')}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ai-advantage"
                       data-ani>
                    <div class="container">
                      <div class="develop-title">
                        <span class="line"></span>
                        <span class="title-text">{{$t('solution0_advantage00')}}</span>
                        <span class="line"></span>
                      </div>
                      <div class="row">
                        <div class="col-sm-5"
                             style="padding-top:46px">
                          <div class="row row-10">
                            <div class="col-sm-6">
                              <div data-aos="fade-up"
                                   data-aos-delay="50"
                                   class="advantage-box aos-init aos-animate"><i class="iconfont icon-pcduan f70"></i>
                                <p class="p16">{{$t('solution0_advantage01')}}</p>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div data-aos="fade-up"
                                   data-aos-delay="100"
                                   class="advantage-box aos-init aos-animate"><span class="iconfont icon-tuichu f70"></span>
                                <p class="p16">{{$t('solution0_advantage02')}}</p>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div data-aos="fade-up"
                                   data-aos-delay="150"
                                   class="advantage-box aos-init aos-animate"><span class="iconfont icon-gouwuche1 f70"></span>
                                <p class="p16">{{$t('solution0_advantage03')}}</p>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div data-aos="fade-up"
                                   data-aos-delay="200"
                                   class="advantage-box aos-init aos-animate"><span class="iconfont icon-pcduan f70"></span>
                                <p class="p16">{{$t('solution0_advantage04')}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-7">
                          <div data-aos="zoom-in"
                               data-aos-delay="100"
                               class="advantage-show aos-init aos-animate animated infinite upDown">
                            <ul>
                              <li data-aos="zoom-in"
                                  data-aos-delay="150"
                                  class="aos-init one aos-animate animated infinite upDown"
                                  style="background-image:url(img/Solution/safeVillage_a_1.jpg);">
                                <p data-aos="zoom-in"
                                   data-aos-delay="500"
                                   class="aos-init aos-animate"><span class="iconfont icon-tag"></span>{{$t('solution0_advantage01')}}</p>
                              </li>
                              <li data-aos="zoom-in"
                                  data-aos-delay="200"
                                  class="aos-init two aos-animate animated infinite upDown"
                                  style="background-image:url(img/Solution/safeVillage_a_2.jpg);">
                                <p data-aos="zoom-in"
                                   data-aos-delay="500"
                                   class="aos-init aos-animate"><span class="iconfont icon-tag"></span>{{$t('solution0_advantage03')}}</p>
                              </li>
                              <li data-aos="zoom-in"
                                  data-aos-delay="250"
                                  class="aos-init three aos-animate animated infinite upDown"
                                  style="background-image:url(img/Solution/safeVillage_a_3.jpg);">
                                <p data-aos="zoom-in"
                                   data-aos-delay="500"
                                   class="aos-init aos-animate"><span class="iconfont icon-tag"></span>{{$t('solution0_advantage04')}}</p>
                              </li>
                              <li data-aos="zoom-in"
                                  data-aos-delay="300"
                                  class="aos-init four aos-animate animated infinite upDown"
                                  style="background-image:url(img/Solution/safeVillage_a_4.jpg);">
                              </li>
                              <li data-aos="zoom-in"
                                  data-aos-delay="350"
                                  class="aos-init five aos-animate animated infinite upDown"
                                  style="background-image:url(img/Solution/safeVillage_a_5.jpg);">
                                <p data-aos="zoom-in"
                                   data-aos-delay="500"
                                   class="aos-init aos-animate"><span class="iconfont icon-tag"></span>{{$t('solution0_advantage02')}}</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ai-advantage bcw"
                       data-ani>
                    <div class="container">
                      <div class="develop-title">
                        <span class="line"></span>
                        <span class="title-text">{{$t('solution0_function00')}}</span>
                        <span class="line"></span>
                      </div>
                      <div class="solutionDitails">
                        <b-card-group deck>
                          <b-card>
                            <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/远程看店.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poL">
                                <h3>{{$t('solution0_function01')}}</h3>
                              </div>
                            </div>
                          </b-card>
                          <b-card>
                            <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/实时查岗.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poL">
                                <h3>{{$t('solution0_function02')}}</h3>
                              </div>
                            </div>
                          </b-card>
                          <b-card>
                            <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/店内动态.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poL">
                                <h3>{{$t('solution0_function03')}}</h3>
                              </div>
                            </div>
                          </b-card>
                        </b-card-group>

                        <!-- <b-card-group deck>
                          <b-card>
                            <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/a-06.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poR">
                                <h3>{{$t('solution0_function04')}}</h3>
                              </div>
                            </div>
                          </b-card>
                          <b-card>
                            <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/a-07.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poL">
                                <h3>{{$t('solution0_function05')}}</h3>
                              </div>
                            </div>
                          </b-card>
                          <b-card>
                            <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/a-08.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poR">
                                <h3>{{$t('solution0_function06')}}</h3>
                              </div>
                            </div>
                          </b-card>
                        </b-card-group> -->
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('solution0_Label2')"
                       name="customer">
            <div id="ai-main">
              <transition name="plus-icon">
                <div v-if="activeName == 'customer'">
                  <div class="ai-advantage bcw pb0"
                       data-ani>
                    <div class="container h350">
                      <div class="develop-title">
                        <span class="line"></span>
                        <span class="title-text">{{$t('solution0_Label2')}}</span>
                        <span class="line"></span>
                      </div>
                      <div class="row">
                        <div class="col-xs-12 col-sm-6"
                             style="background-image:url(/static/img/babyOnline_intro.jpg);"><img src="img/Solution/客流统计.jpg"
                               alt=""
                               class="img-block"></div>
                        <div class="txtbox col-xs-12 col-sm-6 ">
                          <p style="text-align: left;">{{$t('solution0_Descript2')}}
                          </p>
                          <p style="text-align: left;"><strong>{{$t('solution0_DescriptH000')}}</strong></p>
                          <p style="text-align: left;">{{$t('solution0_DescriptP000')}}</p>
                          <p style="text-align: left;"><strong>{{$t('solution0_DescriptH001')}}</strong></p>
                          <p style="text-align: left;">{{$t('solution0_DescriptP001')}}</p>
                          <p style="text-align: left;"><strong>{{$t('solution0_DescriptH002')}}</strong></p>
                          <p style="text-align: left;">{{$t('solution0_DescriptP002')}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ai-advantage"
                       data-ani>
                    <div class="container">
                      <div class="develop-title">
                        <span class="line"></span>
                        <span class="title-text">{{$t('solution0_advantage000')}} </span>
                        <span class="line"></span>
                      </div>
                      <div class="row">
                        <div class="col-sm-5"
                             style="padding-top:46px">
                          <div class="row row-10">
                            <div class="col-sm-6">
                              <div data-aos="fade-up"
                                   data-aos-delay="50"
                                   class="advantage-box aos-init aos-animate"><i class="iconfont icon-pcduan f70"></i>
                                <p class="p16">{{$t('solution0_advantage001')}}</p>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div data-aos="fade-up"
                                   data-aos-delay="100"
                                   class="advantage-box aos-init aos-animate"><span class="iconfont icon-tuichu f70"></span>
                                <p class="p16">{{$t('solution0_advantage002')}}</p>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div data-aos="fade-up"
                                   data-aos-delay="150"
                                   class="advantage-box aos-init aos-animate"><span class="iconfont icon-gouwuche1 f70"></span>
                                <p class="p16">{{$t('solution0_advantage003')}}</p>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div data-aos="fade-up"
                                   data-aos-delay="200"
                                   class="advantage-box aos-init aos-animate"><span class="iconfont icon-pcduan f70"></span>
                                <p class="p16">{{$t('solution0_advantage004')}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-7">
                          <div data-aos="zoom-in"
                               data-aos-delay="100"
                               class="advantage-show aos-init aos-animate animated infinite upDown">
                            <ul>
                              <li data-aos="zoom-in"
                                  data-aos-delay="150"
                                  class="aos-init one aos-animate animated infinite upDown"
                                  style="background-image:url(img/Solution/safeVillage_a_1.jpg);">
                                <p data-aos="zoom-in"
                                   data-aos-delay="500"
                                   class="aos-init aos-animate"><span class="iconfont icon-tag"></span>{{$t('solution0_advantage001')}}</p>
                              </li>
                              <li data-aos="zoom-in"
                                  data-aos-delay="200"
                                  class="aos-init two aos-animate animated infinite upDown"
                                  style="background-image:url(img/Solution/safeVillage_a_2.jpg);">
                                <p data-aos="zoom-in"
                                   data-aos-delay="500"
                                   class="aos-init aos-animate"><span class="iconfont icon-tag"></span>{{$t('solution0_advantage003')}}</p>
                              </li>
                              <li data-aos="zoom-in"
                                  data-aos-delay="250"
                                  class="aos-init three aos-animate animated infinite upDown"
                                  style="background-image:url(img/Solution/safeVillage_a_3.jpg);">
                                <p data-aos="zoom-in"
                                   data-aos-delay="500"
                                   class="aos-init aos-animate"><span class="iconfont icon-tag"></span>{{$t('solution0_advantage004')}}</p>
                              </li>
                              <li data-aos="zoom-in"
                                  data-aos-delay="300"
                                  class="aos-init four aos-animate animated infinite upDown"
                                  style="background-image:url(img/Solution/safeVillage_a_4.jpg);">
                              </li>
                              <li data-aos="zoom-in"
                                  data-aos-delay="350"
                                  class="aos-init five aos-animate animated infinite upDown"
                                  style="background-image:url(img/Solution/safeVillage_a_5.jpg);">
                                <p data-aos="zoom-in"
                                   data-aos-delay="500"
                                   class="aos-init aos-animate"><span class="iconfont icon-tag"></span>{{$t('solution0_advantage002')}}</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ai-advantage bcw"
                       data-ani>
                    <div class="container">
                      <div class="develop-title">
                        <span class="line"></span>
                        <span class="title-text">{{$t('solution0_function000')}}</span>
                        <span class="line"></span>
                      </div>
                      <div class="solutionDitails">
                        <b-card-group deck>
                          <b-card>
                              <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/a-06.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poL">
                                <h3>{{$t('solution0_function004')}}</h3>
                              </div>
                            </div>
                          </b-card>
                          <b-card>
                            <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/a-04.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poL">
                                <h3>{{$t('solution0_function002')}}</h3>
                              </div>
                            </div>
                          </b-card>
                          <b-card>
                            <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/a-05.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poL">
                                <h3>{{$t('solution0_function003')}}</h3>
                              </div>
                            </div>
                          </b-card>
                        </b-card-group>

                        <!-- <b-card-group deck>
                          <b-card>
                            <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/a-06.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poR">
                                <h3>{{$t('solution0_function004')}}</h3>
                              </div>
                            </div>
                          </b-card>
                          <b-card>
                            <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/a-07.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poL">
                                <h3>{{$t('solution0_function005')}}</h3>
                              </div>
                            </div>
                          </b-card>
                          <b-card>
                            <div class="block mypointer">
                              <div class="pic lazyload-v2 picImg2 over"
                                   style="height: auto; background: none;">
                                <div class="lazyload-v2-wrap">
                                  <img src="img/Solution/a-08.jpg"
                                       alt=""
                                       class="bg100">
                                </div>
                              </div>
                              <div class="poR">
                                <h3>{{$t('solution0_function006')}}</h3>
                              </div>
                            </div>
                          </b-card>
                        </b-card-group> -->
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </el-tab-pane>
        </el-tabs>
        <!-- <ul class="">
          <li @click="change('picture')"
              :class="menu == 'picture' ? 'active' : ''">客户画像</li>
          <li @click="change('store')"
              :class="menu == 'store' ? 'active' : ''">远程巡店</li>
          <li @click="change('customer')"
              :class="menu == 'customer' ? 'active' : ''">客流统计</li>
        </ul> -->
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import '../../node_modules/swiper/css/swiper.css'
import topNav from '../components/top'
import banner from '../components/banner'
import footerBot from '../components/footerBot'
import { mapMutations } from 'vuex'
// import AOS from 'aos'
export default {
  name: 'about',
  data() {
    return {
      activeName: 'picture',
      Mobile: 650,
      curmenu: 'picture',
      swiperOption: {
        slidesPerView: document.body.clientWidth > 480 ? 3 : 1,
        spaceBetween: document.body.clientWidth > 480 ? 100 : 0,
        slidesPerGroup: document.body.clientWidth > 480 ? 3 : 1,
        loop: false,
        loopFillGroupWithBlank: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        // centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      fdata: {
        h1: 'homenav1RT',
        h2:
          '支持超过10万类常见物体和场景识别，接口返回图片内1个或多个物体的名称，并可获取百科信息。适用于图像或视频内容分析、拍照识图等业务场景',
        style: {
          background:
            "url('img/Solution/新零售-02.jpg') no-repeat 100% 100% !important"
        },
        myheaderstyle: {
          display: 'flex',
          'justify-content': 'space-around'
        }
        // imgurl: "../../img/Ai/物体识别.jpg"
      },
      list: [
        {
          h: 'homenav1RT0',
          p: [
            'homenav1RT0P0',
            'homenav1RT0P1',
            'homenav1RT0P2',
            'homenav1RT0P3'
          ],
          showContent: false,
          imgSrc: 'img/Ai/retail/vip.png'
        },
        {
          h: 'homenav1RT1',
          p: [
            'homenav1RT1P0',
            'homenav1RT1P1',
            'homenav1RT1P2',
            'homenav1RT1P3'
          ],
          showContent: false,
          imgSrc: 'img/Ai/retail/stay.png'
        },
        {
          h: 'homenav1RT2',
          p: [
            'homenav1RT2P0',
            'homenav1RT2P1',
            'homenav1RT2P2',
            'homenav1RT2P3'
          ],
          showContent: false,
          imgSrc: 'img/Ai/retail/stat.png'
        },
        {
          h: 'homenav1RT3',
          p: [
            'homenav1RT3P0',
            'homenav1RT3P1',
            'homenav1RT3P2',
            'homenav1RT3P3'
          ],
          showContent: false,
          imgSrc: 'img/Ai/retail/region.png'
        },
        {
          h: 'homenav1RT4',
          p: ['homenav1RT4P0', 'homenav1RT4P1', 'homenav1RT4P2'],
          showContent: false,
          imgSrc: 'img/Ai/retail/duty.png'
        },
        {
          h: 'homenav1RT5',
          p: ['homenav1RT5P0', 'homenav1RT5P1'],
          showContent: false,
          imgSrc: 'img/Ai/retail/video.png'
        }
      ],
      tabIndex: 0,
      formData: new FormData(),
      img0: {},
      img1: {},
      img2: {},
      img3: {},
      img4: {},
      img5: {},
      img6: {},
      img7: {},
      activeName: 'picture',
      fil: '',
      imgLen: 0,
      isActive: 0,
      isActiveS: 0,
      screenWidth: document.body.clientWidth,
      showmobile: false,
      text: `
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
          richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
          brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
          tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
          assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
          wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
          vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
          synth nesciunt you probably haven't heard of them accusamus labore VHS.
        `
    }
  },
  components: {
    topNav,
    banner,
    footerBot,
    Swiper,
    SwiperSlide
  },

  methods: {
    jump(index) {
      // 用 class="d_jump" 添加锚点
      let jump = document.querySelectorAll('.d_jump')
      let total = jump[index].offsetTop
      let distance =
        document.documentElement.scrollTop || document.body.scrollTop
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 50
      if (total > distance) {
        smoothDown()
      } else {
        let newTotal = distance - total
        step = newTotal / 50
        smoothUp()
      }
      function smoothDown() {
        if (distance < total) {
          distance += step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          setTimeout(smoothDown, 10)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
        }
      }
      function smoothUp() {
        if (distance > total) {
          distance -= step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          setTimeout(smoothUp, 10)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
        }
      }
    },
    showModal(el) {
      if (this.showmobile) {
        this.$refs['my-modal' + el].show()
      }
    },
    changeActive(val) {
      this.isActive = val
    },
    changeActiveS(val) {
      this.isActiveS = val
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg', 'text']
      } else {
        return ['bg-light', 'text']
      }
    },
    addActive(val) {
      this.menu = val
    },
    triggerFile(val) {
      var myfile = document.getElementById('file' + val)
      myfile.click()
    },
    change(val) {
      this.menu = val
      AOS.init()
    },
    addImg(event, val) {
      console.log(event.target.files[0])
      var inputDOM = event.target.files[0]
      var reader = new FileReader()
      var that = this
      reader.readAsDataURL(inputDOM)
      reader.onload = function(e) {
        that['img' + val] = this.result
      }
    },
    changeContent(index) {
      //通过index拿到当前值
      this.list.forEach((v, i) => {
        if (i != index) {
          v.showContent = false
        }
      })
      this.list[index].showContent = !this.list[index].showContent
    }
  },
  mounted() {
    AOS.init()
    this.linkClass(1)
    this.changeContent(0)
    const that = this
    if (this.screenWidth < 480) {
      this.showmobile = true
      this.Mobile = window.screen.height
    } else {
      this.showmobile = false
    }
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
        console.log(that.screenWidth)
        if (that.screenWidth < 400) {
          that.showmobile = true
        } else {
          that.showmobile = false
        }
      })()
    }
  },
  watch: {
    $route(to, from) {
      if (to.query.id) {
        console.log(to.query.id)
        this.activeName = to.query.id
        if (this.menu == 'picture') {
          this.tabIndex = 0
          this.changeContent(0)
        } else if (this.menu == 'store') {
          this.tabIndex = 1
          this.changeContent(1)
        } else if (this.menu == 'customer') {
          this.tabIndex = 2
          this.changeContent(2)
        } else if (this.menu == 'hotspot') {
          this.tabIndex = 3
          this.changeContent(3)
        } else if (this.menu == 'employee') {
          this.tabIndex = 4
          this.changeContent(4)
        } else if (this.menu == 'patrol') {
          this.tabIndex = 5
          this.changeContent(5)
        }
      } else {
        this.activeName = 'picture'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fdr {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
}
.fdr img {
  width: 50%;
  text-align: right;
  float: right;
  margin-right: 30px;
}
.fdr .poL {
  height: 320px;
  display: flex;
  justify-content: center;
  width: 50%;
  position: relative;
  flex-direction: column;
  padding: 40px;
  position: absolute;
  left: 0;
}
.bgg {
  background: rgba(228, 227, 225, 0.4);
}
.bgg .bcw {
  background: unset;
}
.fdl {
  display: flex;
  align-items: center;
  flex-direction: row;
}
.fdl img {
  width: 50%;
  text-align: right;
  float: left;
  margin-right: 30px;
}
.fdl .poR {
  height: 320px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  position: relative;
  padding: 40px;
  position: absolute;
  right: -50px;
  // background: rgba(228, 227, 225, 0.4);
}
@media screen and (max-width: 480px) {
  .fdr img {
    width: 100%;
    text-align: right;
    float: right;
    margin-right: 0px;
  }
  .fdr .poL {
    height: auto;
    width: 100%;
    position: relative;
    padding: 40px;
    position: absolute;
    left: 0;
    background: rgba(228, 227, 225, 0.8);
  }
  .fdl img {
    width: 100%;
    text-align: right;
    float: left;
    margin-right: 0px;
  }
  .fdl .poR {
    height: auto;
    width: 100% !important;
    position: relative;
    padding: 40px;
    position: absolute;
    right: 0px;
    background: rgba(228, 227, 225, 0.8);
  }
}

.mymimg {
  margin: 0 auto;
  /* width: 100%; */
  height: unset !important;
}
.myicon {
  width: 80px;
  height: 80px;
}
#headerwrap h2 {
  font-size: 20px;
  text-align: left;
}
blockquote {
  border: none;
}
#navbar-main {
  /* height: 144px; */
}
#about-main {
  padding-bottom: 30px;
}
#headerwrap {
  /* background: url(../../public/img/about/gyks_banner@3x.jpg) no-repeat center top; */
  display: flex;
  align-items: center;
  justify-content: center;
}
#headerwrap h1 {
  margin-top: 0;
}

#headerwrap h2 {
  color: white;
  margin-bottom: 0;
}

#ai-main .img-banner {
  height: 380px;
  width: 100%;
  /* background: url(img/about/gyks_banner@3x.jpg) no-repeat 100% center; */
  background-size: 100% 100%;
  box-sizing: border-box;
}

#ai-main .img-banner h3 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
}

@media screen and (max-width: 480px) {
  #ai-main .img-banner {
    height: 170px;
    width: 100%;
    background: url(../../public/img/about/gyks_banner@3x.jpg) no-repeat center;
    background-size: 100% 100%;
  }
  .mymimg {
    margin: 0 auto;
    width: 100%;
    height: unset !important;
  }
}
#ai-main .company-info {
  /* padding: 20px 0px; */
  box-sizing: border-box;
}
.company-develop {
  padding-top: 40px;
}
#ai-main .info-title,
#ai-main .develop-title {
  text-align: center;
  margin-bottom: 40px;
  margin-top: 20px;
}
#ai-main .info-main {
  display: flex;
  flex-direction: column;
  /* align-items: ; */
}
#ai-main .info-title .title-text,
#ai-main .develop-title .title-text {
  font-size: 30px;
}
.h350 {
  height: 500px;
}
.tab-content {
  background-color: #fff;
  border: 1px solid #ddd;
  border-top: 0;
  padding: 15px 15px 5px;
  box-sizing: border-box;
}

.well {
  box-shadow: none;
  background-color: rgba(0, 0, 0, 0.05);
}

#headerwrap p {
  font-weight: 300;
  text-align: center;
  letter-spacing: 1px;
}
.btn-outline-primary {
  color: black;
  border-color: #ccc;
}
.btn-outline-primary:hover {
  color: white;
}
.ai-advantage {
  background: rgb(245, 245, 245);
  padding: 40px 0px 60px;
}
.ai-advantage.bgw {
}
.ai-advantage .card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: space-between; */
}
.ai-advantage .card-body .myicon {
  /* background-image: url(../../public/img/allicon.png); */
  /* background-position: 0 -256px;*/
  margin-bottom: 20px;
}

.ai-advantage .card-body .myicon.icon0 {
  background-image: url(../../public/img/Ai/retail/lowcost.png);
}
.ai-advantage .card-body .myicon.icon1 {
  background-image: url(../../public/img/Ai/retail/fastdeploy.png);
}
.ai-advantage .card-body .myicon.icon2 {
  background-image: url(../../public/img/Ai/retail/newbiz.png);
}
.ai-advantage .card-body .myicon.icon3 {
  background-image: url(../../public/img/Ai/body/remove.png);
}
.ai-advantage .card-body .myicon.icon4 {
  background-image: url(../../public/img/Ai/body/rate.png);
}
.ai-advantage .card-body .myicon.icon5 {
  background-image: url(../../public/img/Ai/body/customize.png);
}
.card-deck:nth-child(n + 1) {
  margin-top: 30px;
}
.card-text p {
  text-align: left;
}
.card {
  border: none;
  background: unset;
}
.ai-scene {
  padding: 60px 0;
}
.ai-scene .card {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ai-advantage .card .card-body h4 {
  text-align: center;
}

.ai-scene .card .card-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
}
.ai-scene .card .card-body .card-text {
  flex: 1;
}
.ai-scene .card .card-body .card-text h4 {
  font-size: 18px;
}
.ai-scene .card .card-body .card-text p {
  font-size: 14px;
}
.ai-scene .card .card-body .myleftIcon {
  /* background-image: url(../../public/img/allicon.png); */
  /* background-position: -269px -340px; */
  width: 56px;
  height: 56px;
  display: block;
  margin-right: 20px;
}
.ai-scene .card .card-body .myleftIcon.icon0 {
  background-image: url(../../public/img/Ai/retail/lowcost.png);
}
.ai-scene .card .card-body .myleftIcon.icon1 {
  background-image: url(../../public/img/Ai/retail/fastdeploy.png);
}
.ai-scene .card .card-body .myleftIcon.icon2 {
  background-image: url(../../public/img/Ai/retail/newbiz.png);
}

.ai-scene .card img {
  width: 50%;
}

.ai-parter {
  background: rgb(245, 245, 245);
  padding: 60px 0;
}
.partner-sec {
  display: flex;
  align-items: center;
  justify-content: center;
}
.partner-sec .col-6 {
  margin-bottom: 20px;
}
.partner-sec > div {
  padding: 20px;
  flex: 1;
}
.partner-sec .container {
  padding: 10px;
  width: 100%;
  background-color: white;
  border-radius: 6px;
}
.partner-sec img {
  width: 80%;
}
.ai-parter .develop-title .title-text {
  color: #2c3e50;
}
.ai-sec {
  padding: 60px 0px 60px;
}
.fileGroup {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  /* height: 350px; */
  text-align: left;
  padding: 0 48px;
}

.imgBottom {
  position: absolute;
  bottom: 0;
}

.fileGroup > div {
  position: relative;
  border: 1px solid;
  padding: 40px;
  height: 260px;
}
@media screen and (max-width: 480px) {
  .h350 {
    height: auto;
  }
  .fileGroup {
    flex-wrap: wrap;
    height: auto;
  }
  .fileGroup > div {
    width: 100%;
    position: relative;
  }
  .json_right {
    height: 300px;
  }
}

.fileGroup .json_right {
  border: 1px solid lightgray;
  height: 300px;
}

.fileGroup .imgShow {
  width: 100%;
  height: 300px;
  border: 1px solid lightgray;
}
.fileGroup .imgShow img {
  /* width: 100%; */
  height: 100%;
}
.fileGroup .json_right {
  background: aliceblue;
}
#file0,
#file1,
#file2,
#file3,
#file4,
#file5,
#file6,
#file7 {
  display: none;
}
.fileGroup .tips {
  position: absolute;
  left: 0;
  top: 0;
  padding: 5px 10px;
  background-color: #e6fafd;
  font-size: 14px;
  color: gray;
}
.btn-group {
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.imgSec {
  width: 100%;
  height: 100%;
  overflow: hidden;
  list-style-type: none;
}
.compare {
  width: 20%;
  margin-top: 30px;
}
.rt60 {
  position: relative;
  top: -60px;
  margin-bottom: -60px;
}
.mb0 {
  margin-bottom: 0;
}
.w100 {
  width: 70%;
}

.blg {
  border: 1px solid lightgray;
}

.myclass {
  padding: 1.5rem !important;
  background: rgba(0, 0, 0, 0.03);
}

.hair-line-border:after,
.hair-line-top:after {
  content: '';
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  width: 200%;
  height: 200%;
  border: 1px solid #e1e1e1;
  -webkit-transform: scale(0.5) translateZ(0);
  transform: scale(0.5) translateZ(0);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}
.hair-line-top:after {
  border-width: 1px 0 0;
}
.hair-line-bottom:after {
  border: 1px solid #e1e1e1;
  border-width: 0 0 1px;
}
.hair-line-bottom:after,
.hair-line-left-right-top:after {
  content: '';
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  width: 200%;
  height: 200%;
  -webkit-transform: scale(0.5) translateZ(0);
  transform: scale(0.5) translateZ(0);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}
.hair-line-left-right-top:after {
  border: 1px solid #e1e1e1;
  border-width: 1px 1px 0;
}
.hair-line-top-left:after {
  border: 1px solid #e1e1e1;
  border-width: 1px 0 0 1px;
}
.hair-line-right-bottom:after,
.hair-line-top-left:after {
  content: '';
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  width: 200%;
  height: 200%;
  -webkit-transform: scale(0.5) translateZ(0);
  transform: scale(0.5) translateZ(0);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}
.hair-line-right-bottom:after {
  border: 1px solid #e1e1e1;
  border-width: 0 1px 1px 0;
}
.hair-line-border:after {
  border-radius: 0.166667rem;
}
.ai-news {
  margin-top: 2.944444rem;
  position: relative;
}
.ai-news-content {
  position: relative;
  z-index: 1;
  padding: 1.722222rem;
}
.ai-news-content:before {
  content: '';
  display: inline-block;
  height: 1.833333rem;
  width: 1.833333rem;
  background: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/images/component/aiNews/news.jpg)
    no-repeat;
  background-size: cover;
  margin-right: 1.166667rem;
}
.ai-news-content-title {
  display: inline-block;
  font-size: 1.333333rem;
  color: #000;
  vertical-align: text-bottom;
}
.ai-news-content-more {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  padding-right: 1.722222rem;
  right: 0;
  z-index: 1;
  font-size: 1.166667rem;
  color: #333;
}
.ai-news-list {
  position: relative;
  z-index: 1;
  overflow: hidden;
}
.ai-news-list-items {
  position: relative;
  display: block;
  padding: 1.166667rem 1.722222rem;
}
.ai-news-list-items.hair-line-bottom:after {
  border-style: dashed;
}
.ai-news-list-items:last-child {
  border: none;
}
.ai-news-list-items span {
  position: relative;
  z-index: 2;
  display: inline-block;
  max-width: 23.333333rem;
  font-size: 1.166667rem;
  text-decoration: none;
  color: #000;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}
.ai-news-list-items:before {
  content: '';
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 1.722222rem;
  width: 0.6rem;
  height: 1.166667rem;
  background: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/images/component/aiNews/more.jpg)
    0 no-repeat;
  background-size: cover;
}
.ai-heading {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  padding: 5rem 0 2.5rem;
  font-size: 2rem;
  line-height: 1;
  text-indent: 2px;
  text-align: center;
  font-weight: 700;
  color: #000;
}
.ai-heading.is-white {
  color: #fff;
}
.ai-heading-sub-title {
  font-weight: 400;
  font-size: 1.5rem;
  color: #000;
  text-align: center;
  margin-top: 2.5rem;
}
.ai-accordion {
  margin-bottom: 2.5rem;
}
.ai-accordion:last-child {
  margin-bottom: 0;
}
.ai-accordion-title {
  font-weight: 400;
  font-size: 1.5rem;
  color: #000;
  text-align: center;
  margin-bottom: 1.666667rem;
}
.ai-accordion-items {
  position: relative;
}
.ai-accordion-items.hair-line-left-right-top:nth-child(2):after {
  border-top-left-radius: 0.166667rem;
  border-top-right-radius: 0.166667rem;
}
.ai-accordion-items.hair-line-left-right-top:last-child:after {
  border-bottom-left-radius: 0.166667rem;
  border-bottom-right-radius: 0.166667rem;
}
.ai-accordion-items.hair-line-left-right-top:last-child:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 200%;
  height: 200%;
  border: 1px solid #e1e1e1;
  -webkit-transform: scale(0.5) translateZ(0);
  transform: scale(0.5) translateZ(0);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  border-bottom-left-radius: 0.166667rem;
  border-bottom-right-radius: 0.166667rem;
  border-width: 0 0 1px;
}
.ai-accordion-items-head {
  position: relative;
  z-index: 1;
  padding: 1.666667rem;
  font-size: 0;
  text-align: left;
}
.ai-accordion-items-head:active:after {
  content: '';
  position: absolute;
  background-color: rgba(0, 0, 0, 0.03);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.ai-accordion-items-head-icon {
  display: inline-block;
}
.ai-accordion-items-head-icon,
.ai-accordion-items-head-icon img {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.ai-accordion-items-head-icon img {
  width: 1.944444rem;
  height: 1.944444rem;
}
.ai-accordion-items-head-title {
  display: inline-block;
  vertical-align: top;
  font-size: 1.033333rem;
  color: #000;
  margin-left: 3.055556rem;
}
.ai-accordion-items-head-arrow {
  position: absolute;
  right: 1.666667rem;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  -webkit-transition: -webkit-transform 0.2s linear;
  transition: -webkit-transform 0.2s linear;
  transition: transform 0.2s linear;
  transition: transform 0.2s linear, -webkit-transform 0.2s linear;
}
.ai-accordion-items-head-arrow:before {
  font-size: 1.444444rem;
  content: '\E900';
  color: #ccc;
  font-family: icomoon;
}
.ai-accordion-items-active {
  padding-bottom: 1.25rem;
}
.ai-accordion-items-active .ai-accordion-items-head-arrow {
  -webkit-transform: translateY(-50%) rotate(180deg);
  transform: translateY(-50%) rotate(180deg);
  -webkit-transform-origin: center;
  transform-origin: center;
}
.ai-accordion-items-content {
  position: relative;
  z-index: 1;
  -webkit-transition: all 0.2s linear;
  transition: all 0.2s linear;
  overflow: hidden;
}
.ai-accordion-items-content-link {
  padding: 0.9375rem 1.666667rem 0.979167rem 4.722222rem;
  display: block;
  /* height: 3.722222rem; */
  color: #333;
  text-align: left !important;
}
.ai-accordion-items-content-link-title {
  margin-bottom: 0.25rem;
  line-height: 1.5;
  vertical-align: top;
  font-size: 0.85rem;
}
.ai-accordion-items-content-link-intro {
  color: #666;
  width: 100%;
  display: -webkit-box;
  /* overflow: hidden; */
  /* -webkit-line-clamp: 1; */
  -webkit-box-orient: vertical;
  vertical-align: top;
  line-height: 1.5;
  font-size: 0.85rem;
  text-align: left !important;
}
.layout-img {
  height: 10.444444rem;
  margin-bottom: 1.25rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-left: 1.666667rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-size: cover;
  background-position-x: right;
  background-position-y: 33.333%;
}
.layout-img:active:after {
  background-color: rgba(0, 0, 0, 0.05);
}
.layout-img:last-child {
  margin-bottom: 0;
}
.layout-img-more {
  display: inline-block;
  width: 100%;
  text-align: center;
  font-size: 1.083333rem;
  color: #000;
  padding-top: 0.416667rem;
}
.more-icon {
  display: inline-block;
  vertical-align: middle;
}
.more-icon:before {
  font-size: 0.861111rem;
  content: '\E900';
  color: #000;
  font-family: icomoon;
}
.more-icon-deg {
  -webkit-transform: translateY(-10%) rotate(180deg);
  transform: translateY(-10%) rotate(180deg);
  -webkit-transform-origin: center;
  transform-origin: center;
}
.layout-img-gray .layout-img-name {
  width: 18.666667rem;
  color: #000;
}
.layout-img-gray .layout-img-intro {
  color: #666;
}
.layout-img-blue .layout-img-intro,
.layout-img-blue .layout-img-name,
.layout-img-ecology .layout-img-intro,
.layout-img-ecology .layout-img-name {
  color: #fff;
}
.layout-img-ecology .layout-img-intro {
  width: 16.25rem;
}
.layout-img-ecology {
  height: 12.083333rem;
}
.layout-img-intro {
  width: 19.5rem;
}
.layout-img-name {
  font-weight: 700;
  padding-bottom: 0.5rem;
  line-height: 1.5;
  font-size: 1.333333rem;
  white-space: nowrap;
}
.layout-img-intro {
  font-size: 1.083333rem;
  line-height: 1.638889rem;
}
.ai-logos {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -ms-flex-pack: distribute;
  justify-content: space-around;
}
.ai-logos-link {
  margin-bottom: 3.888889rem;
  display: inline-block;
  width: 8.888889rem;
  height: 4.5rem;
}
.ai-logos-link:last-child {
  margin-right: 0;
}
.ai-logos-link-img {
  width: 100%;
  height: 100%;
}
.ai-section.ai-section-customize {
  padding-bottom: 6.666rem;
}
.ai-layout-e {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
  -ms-flex-pack: distribute;
  justify-content: space-around;
}
.ai-layout-e-link {
  position: relative;
  padding-bottom: 50%;
  display: block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 50%;
  height: 0;
}
.ai-layout-e-link-a {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  font-size: 1.25rem;
  color: #000;
}
.ai-layout-e-link-a-intro {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}
.ai-layout-e-link-a-intro-icon {
  margin-bottom: 0.833333rem;
  width: 3.333333rem;
  height: 3.333333rem;
}
.ai-layout-e-product .ai-layout-e-link-a-intro-icon {
  width: 6.111111rem;
  height: 6.111111rem;
}
.logo-wall {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.logo-wall,
.logo-wall-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.logo-wall-item {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.logo-wall-logo {
  max-width: 100%;
  max-height: 100%;
}
.ai-link-btn {
  display: inline-block;
  width: 8.277778rem;
  height: 2.583333rem;
  line-height: 1;
  font-size: 1.083rem;
  padding: 0.7rem 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #fff;
  background-color: #3e89f1;
  text-align: center;
}
.more-customer-case-container {
  padding: 0.833rem 0 5rem;
  text-align: center;
}
.ai-layout-f-items {
  padding: 0 1.666667rem 3.333333rem;
}
.ai-layout-f-items-text {
  margin-bottom: 0.527778rem;
  overflow: hidden;
}
.ai-layout-f-items-text-icon {
  float: left;
  width: 1.944444rem;
  height: 1.944444rem;
  margin-right: 1.25rem;
}
.ai-layout-f-items-text-title {
  float: left;
  color: #000;
  font-size: 1.333333rem;
  line-height: 1.944444rem;
}
.ai-layout-f-items-content {
  overflow: hidden;
}
.ai-layout-f-items-content-des {
  float: left;
  width: 21.722222rem;
  line-height: 1.638889rem;
  color: #666;
  font-size: 1.027778rem;
}
.ai-layout-f-items:last-child {
  padding-bottom: 0;
}
.ai-layout-f-none {
  height: 1.638889rem;
}
.ecology-represent {
  margin-bottom: 5rem;
}
.ecology-more-partner-container {
  text-align: center;
  margin: 2.25rem 0 5rem;
}
.ecology-more-partner {
  color: #3b85f5;
  font-size: 1.083rem;
}
.ecology-more-partner:after {
  content: '';
  display: inline-block;
  vertical-align: middle;
  margin-left: 0.41666rem;
  width: 0.333rem;
  height: 0.5rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAASBAMAAACdhyI/AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURTuF9f///4Wz+d/r/kOK9lya97bS/Pj7/yufj/gAAAA4SURBVAjXY1AXBAEGVkMwxeAGoRjUIRRIGEiBhEEUUBhMsRqCKQY3ZAoqqI6kAapdHcloqEUQawGcrQadM6slVwAAAABJRU5ErkJggg==)
    no-repeat;
  background-size: contain;
}
.ai-facilitator-items {
  padding: 0 0.694444rem;
  margin-bottom: 2.5rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.ai-facilitator-items:active:after {
  top: -1rem;
  bottom: -1rem;
}
.ai-facilitator-items-logo {
  display: inline-block;
  width: 6.944444rem;
  height: 6.944444rem;
  margin-right: 1.25rem;
}
.ai-facilitator-items-content {
  display: inline-block;
}
.ai-facilitator-items-content-link {
  display: block;
  font-size: 1.333333rem;
  line-height: 1.5rem;
  margin-bottom: 1rem;
  color: #000;
}
.ai-facilitator-items-content-des {
  font-size: 1rem;
  line-height: 1.5rem;
  color: #666;
}
.ai-top-nav {
  z-index: 3;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 5.333333rem;
  line-height: 5.333333rem;
  background-color: #000;
  padding: 0 1.04rem 0 0;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
}
.ai-top-nav-main {
  position: relative;
  z-index: 1;
  top: 0;
  height: 100%;
  -webkit-transition: top 0.2s linear;
  transition: top 0.2s linear;
}
.ai-top-nav-show-extra {
  top: -100%;
}
.ai-top-nav-item {
  height: 100%;
}
.ai-top-nav.is-hide {
  -webkit-transform: translateY(-5.333rem);
  transform: translateY(-5.333rem);
  opacity: 0.5;
}
.ai-top-nav a {
  height: 2rem;
  line-height: 1;
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 1.3888rem;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.ai-top-nav-logo {
  width: 14.055rem;
  max-height: 2.444rem;
}
.ai-top-nav-menu {
  position: absolute;
  z-index: 2;
  right: 1.3888rem;
  top: 50%;
  width: 1.583rem;
  height: 1.583rem;
  background: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/images/home/menu.png)
    no-repeat 50%;
  background-size: 100% 100%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.ai-top-nav-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 4;
  background-color: rgba(0, 0, 0, 0.45);
}
.ai-slide-nav-tree {
  position: relative;
}
.ai-slide-nav-title {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
  background-color: #1e1e1e;
}
.ai-slide-nav-title:active:before {
  content: '';
  position: absolute;
  background-color: hsla(0, 0%, 100%, 0.03);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.ai-slide-nav-accordion:after {
  position: absolute;
  content: '\E900';
  top: 50%;
  right: 1.25rem;
  color: #fff;
  opacity: 0.36;
  font-family: icomoon;
  font-size: 1.2rem;
  -webkit-transition: -webkit-transform 0.2s linear;
  transition: -webkit-transform 0.2s linear;
  transition: transform 0.2s linear;
  transition: transform 0.2s linear, -webkit-transform 0.2s linear;
  -webkit-transform: translateY(-50%) rotate(0);
  transform: translateY(-50%) rotate(0);
  -webkit-transform-origin: center;
  transform-origin: center;
}
.ai-slide-nav-accordion-active:after {
  -webkit-transform: translateY(-50%) rotate(180deg);
  transform: translateY(-50%) rotate(180deg);
}
.ai-slide-nav-text {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 5.52rem;
  line-height: 5.52rem;
  overflow: hidden;
}
.ai-slide-nav .ai-slide-nav-tree-non-leaf:after {
  width: 100%;
}
.ai-slide-nav .ai-slide-nav-tree-non-leaf:after,
.ai-slide-nav .line-bottom:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  border-top: 1px solid hsla(0, 0%, 100%, 0.15);
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  z-index: 9;
}
.ai-slide-nav .line-bottom:after {
  display: block;
  right: 0;
}
.ai-slide-nav-level-1 .ai-slide-nav-text {
  position: relative;
  padding-left: 1.66rem;
  color: #fff;
  font-size: 1.5rem;
}
.ai-slide-nav-level-1 .ai-slide-nav-tree-non-leaf:before {
  left: 0;
}
.ai-slide-nav-level-2 .ai-slide-nav-text {
  font-size: 1.16rem;
  color: #999;
  padding-left: 2.5rem;
}
.ai-slide-nav-level-2 .ai-slide-nav-title {
  background-color: #141414;
}
.ai-slide-nav-level-2 .ai-slide-nav-tree-non-leaf:after {
  left: 2.5rem;
}
.ai-slide-nav-level-2.ai-slide-nav-tree-active:after {
  left: 0;
}
.ai-slide-nav-level-3 .ai-slide-nav-text {
  padding-left: 3.5rem;
}
.ai-slide-nav-level-3.ai-slide-nav-tree-active:after {
  left: 2.5rem;
}
.ai-slide-nav-level-3.ai-slide-nav-tree-active:last-child:after {
  display: none;
}
.ai-slide-nav-tree-active:after {
  display: block;
  content: '';
  position: absolute;
  right: 0;
  bottom: 0;
  border-top: 1px solid hsla(0, 0%, 100%, 0.15);
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  z-index: 9;
}
.ai-slide-nav .ai-slide-nav-accordion-last .ai-slide-nav-tree-non-leaf:after {
  display: none;
}
.ai-slide-nav
  .ai-slide-nav-accordion-active.ai-slide-nav-accordion-last
  .ai-slide-nav-tree-non-leaf:before {
  left: 2.5rem;
}
.ai-slide-nav
  .ai-slide-nav-accordion-active.ai-slide-nav-accordion-last
  .ai-slide-nav-tree-non-leaf:before,
.ai-slide-nav .hair-border {
  display: block;
  content: '';
  position: absolute;
  right: 0;
  bottom: 0;
  border-top: 1px solid hsla(0, 0%, 100%, 0.15);
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  z-index: 9;
}
.ai-slide-nav {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  width: 25.416667rem;
  background-color: #1e1e1e;
  overflow: auto;
  z-index: 99;
  -webkit-transition: -webkit-transform 0.3s linear;
  transition: -webkit-transform 0.3s linear;
  transition: transform 0.3s linear;
  transition: transform 0.3s linear, -webkit-transform 0.3s linear;
}
.ai-slide-nav-hide {
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
}
.ai-slide-nav-main {
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
body,
html {
  margin: 0;
  font-size: 12px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
  font-family: tahoma, arial, Hiragino Sans GB, Microsoft YaHei, sans-serif;
}
* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
a {
  text-decoration: none;
}
dd,
h1,
h2,
h3,
ol,
ul {
  margin: 0;
  padding: 0;
}
ol,
ul {
  list-style: none;
}
@media only screen and (min-device-width: 375px) and (max-device-width: 812px) {
  html {
    font-size: 12px;
  }
}
@media only screen and (min-device-width: 812px) {
  html {
    font-size: 14px;
  }
}
@media only screen and (max-device-width: 350px) {
  html {
    font-size: 10px;
  }
  html .ai-swipe {
    height: 18.666rem;
  }
}
@media only screen and (min-device-width: 350px) and (max-device-width: 374px) {
  html {
    font-size: 11px;
  }
  html .ai-swipe {
    height: 19.666rem;
  }
}
@font-face {
  font-family: icomoon;
  src: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/fonts/icomoon.eot);
  src: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/fonts/icomoon.eot#iefix)
      format('embedded-opentype'),
    url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/fonts/icomoon.ttf)
      format('truetype'),
    url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/fonts/icomoon.woff)
      format('woff'),
    url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/fonts/icomoon.svg#icomoon)
      format('svg');
  font-weight: 400;
  font-style: normal;
}
[class*=' icon-'],
[class^='icon-'] {
  font-family: icomoon !important;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-correct:before {
  content: '\E901';
}
.icon-down-arrow:before {
  content: '\E900';
}
.icon-menu:before {
  content: '\E9BD';
}
.icon-checkmark:before {
  content: '\EA10';
}
.icon-train:before {
  content: '\E902';
}
.icon-opening:before {
  content: '\E903';
}
.icon-closing:before {
  content: '\E904';
}
.wx-share-icon {
  display: none;
}
.ai-app {
  position: relative;
}
.ai-main {
  padding: 0 1.33rem;
  -webkit-overflow-scrolling: touch;
}
.ai-main-not-scroll {
  overflow: hidden;
}
.ai-slide-item-wrapper {
  padding-top: 0.73rem;
}
.ai-footer {
  margin: 0 -1.33rem;
  padding: 2.777778rem 0;
  background-color: #000;
}
.ai-footer,
.ai-footer a {
  color: hsla(0, 0%, 100%, 0.5);
}
.ai-footer-inner {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.ai-footer-title {
  font-size: 0.916rem;
  color: hsla(0, 0%, 100%, 0.5);
  letter-spacing: 0;
  line-height: 0.916rem;
  text-align: center;
  margin-bottom: 1.25rem;
}
.ai-footer-title .split-line {
  display: inline-block;
  width: 1px;
  height: 1em;
  background-color: #fff;
  opacity: 0.2;
  margin: 0 0.833rem;
  vertical-align: middle;
}
.ai-footer-link {
  text-align: center;
  line-height: 1;
}
.ai-home-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.ai-home-wechat-qrcode {
  position: fixed;
  width: 26.67rem;
  height: 30.31rem;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 1001;
}
.ai-home-wechat-qrcode img {
  max-width: 100%;
  max-height: 100%;
}
.fade-enter-active,
.fade-leave-active {
  -webkit-transition: opacity 0.5s;
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.ai-mini-program-qrcode-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1000;
}
.ai-mini-program-qrcode-content {
  text-align: center;
  position: fixed;
  width: 25rem;
  height: 31.666rem;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 1001;
  background: #fff;
}
.ai-mini-program-qrcode-content img {
  max-width: 100%;
  max-height: 100%;
}
.ai-mini-program-qrcode-content-close {
  text-align: right;
  padding: 1.25rem 1.25rem 1.583rem;
}
.ai-mini-program-qrcode-content-close img {
  width: 1.333rem;
  height: 1.333rem;
}
.ai-mini-program-qrcode-content-text {
  font-size: 1.5rem;
  color: #333;
}
.ai-mini-program-qrcode-content-text div:last-child {
  padding: 1.25rem 0 3rem;
}
.ai-mini-program-qrcode-img {
  width: 15rem;
  height: 15rem;
}
.ai-solution-item {
  display: block;
  margin-bottom: 0.833rem;
  position: relative;
}
.ai-solution-item-bg {
  width: 100%;
  height: 11.33rem;
}
.ai-solution-item-bg.face-check {
  background: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/images/solution/solution_face_check.png)
    no-repeat 50%;
  background-size: cover;
}
.ai-solution-item-bg.face-sign {
  background: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/images/solution/solution_facesignin_bg.png)
    no-repeat 50%;
  background-size: cover;
}
.ai-solution-item-bg.face-identify {
  background: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/images/solution/solution_face_recognition.png)
    no-repeat 50%;
  background-size: cover;
}
.ai-solution-item-bg.face-turnstile {
  background: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/images/solution/solution_face_turnstiles.png)
    no-repeat 50%;
  background-size: cover;
}
.ai-solution-item-bg.smarty-ivs {
  background: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/images/solution/solution_ivs.png)
    no-repeat 50%;
  background-size: cover;
}
.ai-solution-item-bg.ite {
  background: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/images/solution/solution_intelligent_electric_pin.png)
    no-repeat 50%;
  background-size: cover;
}
.ai-solution-item-bg.bot-vis {
  background: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/images/solution/solution_bot_vis.png)
    no-repeat 50%;
  background-size: cover;
}
.ai-solution-item-bg.servicerobot {
  background: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/images/solution/solution_servicerobot.png)
    no-repeat 50%;
  background-size: cover;
}
.ai-solution-item-bg.duer-furniture {
  background: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/images/solution/solution_dueros_furniture.png)
    no-repeat 50%;
  background-size: cover;
}
.ai-solution-item-bg.speech-assist {
  background: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/images/solution/solution_dueros_speech_assist.png)
    no-repeat 50%;
  background-size: cover;
}
.ai-solution-item-bg.arads {
  background: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/images/solution/solution_ar_campagin.png)
    no-repeat 50%;
  background-size: cover;
}
.ai-solution-item-bg.luban {
  background: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/images/solution/solution_luban.jpg)
    no-repeat 50%;
  background-size: cover;
}
.ai-solution-item-text {
  position: absolute;
  left: 1.67rem;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.ai-solution-item-title {
  font-size: 1.33rem;
  font-weight: 600;
  color: #fff;
  margin-bottom: 0.833rem;
}
.ai-solution-item-des {
  font-size: 1rem;
  line-height: 1.5;
  color: #fff;
  max-width: 12.5rem;
  word-wrap: break-word;
}
.ai-solution-item:last-child {
  margin-bottom: 0;
}
.ai-solution {
  position: relative;
}
.ai-solution .ai-solution-container {
  width: 100%;
  overflow: hidden;
  margin-top: 0.416rem;
}
.ai-solution-collapse-btn {
  width: 100%;
  padding-top: 1.94rem;
  color: #333;
  font-size: 1.1666rem;
  text-align: center;
}
.ai-solution-collapse-icon {
  vertical-align: middle;
  display: inline-block;
  background: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/images/solution/V_b@3x.png);
  background-size: 100% 100%;
  -webkit-transition: -webkit-transform 0.2s linear;
  transition: -webkit-transform 0.2s linear;
  transition: transform 0.2s linear;
  transition: transform 0.2s linear, -webkit-transform 0.2s linear;
  -webkit-transform: rotate(0);
  transform: rotate(0);
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  width: 1.833rem;
  height: 1rem;
}
.ai-solution-collapse-icon.is-rotate {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.ai-all-prod-intro {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 17.222222rem;
  background: url(//aip.bdstatic.com/portal-mobile/dist/1582189700706/images/home/all_product_bg.jpg)
    no-repeat 50%;
  background-size: cover;
  text-align: center;
  margin: 0 -1.33rem;
  padding: 0 2.067rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.ai-all-prod-intro-inner {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.ai-all-prod-intro-title {
  font-weight: 700;
  font-size: 2rem;
  color: #000;
  margin-bottom: 2.777778rem;
}
.ai-all-prod-intro-quota {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-left: -1.5rem;
  text-align: center;
}
.ai-all-prod-intro-quota-item {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.ai-all-prod-intro-quota-item .item-num {
  font-size: 2rem;
  color: #000;
  line-height: 1;
  margin-bottom: 0.833333rem;
}
.ai-all-prod-intro-quota-item .item-num span {
  font-size: 2rem;
  vertical-align: bottom;
}
.ai-all-prod-intro-quota-item .item-des {
  font-size: 1.166667rem;
  color: #000;
  line-height: 1;
}
.ai-all-prod-intro-link {
  display: inline-block;
  width: 10rem;
  height: 3rem;
  line-height: 3.4rem;
  position: relative;
  font-size: 1.083rem;
  color: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}
.ai-all-prod-intro-link-wrap {
  text-align: center;
  font-size: 0;
}
.ai-all-prod-intro-link:after {
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  width: 200%;
  height: 200%;
  border: 3px solid #fff;
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}
.ai-home-cus-case-item {
  width: 23.33rem;
  height: 15.11rem;
  padding: 1.67rem 2.5rem;
  margin-right: 1.67rem;
  background-color: #f2f2f2;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: top;
}
.ai-home-cus-case-item:first-child {
  margin-left: 1.67rem;
}
.ai-home-cus-case-item-logo {
  width: 6.667rem;
  height: 4.3055rem;
  margin-bottom: 0.41667rem;
}
.ai-home-cus-case-item-des {
  font-size: 1rem;
  color: #666;
  line-height: 1.5;
  margin-bottom: 1.75rem;
  white-space: normal;
  text-align: left;
  word-wrap: break-word;
}
.ai-home-cus-case {
  margin: 0 -1.33rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.ai-home-cus-case-inner {
  width: 100%;
  padding-bottom: 0.8rem;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
  font-size: 0;
}
.mint-swipe,
.mint-swipe-items-wrap {
  overflow: hidden;
  position: relative;
}
.mint-swipe-items-wrap {
  height: 100%;
}
.mint-swipe-items-wrap > div {
  position: absolute;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  width: 100%;
  height: 100%;
  display: none;
}
.mint-swipe-items-wrap > div.is-active {
  display: block;
  -webkit-transform: none;
  transform: none;
}
.mint-swipe-indicators {
  position: absolute;
  bottom: 1.166667rem;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  white-space: nowrap;
}
.mint-swipe-indicator {
  width: 2.5rem;
  height: 2px;
  display: inline-block;
  background-color: #999;
  opacity: 0.4;
  margin: 0 2.5px;
}
.mint-swipe-indicator.is-active {
  background-color: #198cff;
  opacity: 1;
}
.is-odd-indicator {
  background-color: #fff;
  opacity: 0.5;
}
.is-odd-indicator.is-active {
  background-color: #fff;
  opacity: 1;
}
.has-news .mint-swipe-guide-icon {
  bottom: 7rem;
}
.mint-navbar {
  position: relative;
  background-color: #fff;
  text-align: center;
}
.mint-navbar .mint-tab-item {
  position: relative;
  z-index: 2;
  font-size: 15px;
}
.mint-navbar .mint-tab-item:last-child {
  border-right: 0;
}
.mint-navbar .mint-tab-item.is-selected {
  font-weight: 700;
  margin-bottom: -3px;
}
.mint-navbar.is-fixed {
  top: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 1;
}
.mint-tab-item {
  display: inline-block;
  margin-right: 1.666667rem;
  text-decoration: none;
}
.mint-tab-item:last-child {
  margin-right: 0;
}
.mint-tab-item:active:after {
  background-color: transparent;
}
.mint-tab-item-icon {
  width: 24px;
  height: 24px;
  margin: 0 auto 5px;
}
.mint-tab-item-icon:empty {
  display: none;
}
.mint-tab-item-icon > * {
  display: block;
  width: 100%;
  height: 100%;
}
.mint-tab-item-label {
  color: #333;
  font-size: 1.25rem;
  line-height: 1;
}
.mint-tab-item-inner {
  display: inline-block;
  height: 4rem;
  padding: 0 0.416667rem;
  line-height: 4rem;
}
.is-selected .mint-tab-item-inner {
  border-bottom: 2px solid #333;
}
.mint-tab-container-item {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: 100%;
}
.mint-tab-container {
  overflow: hidden;
  position: relative;
}
.mint-tab-container .swipe-transition {
  -webkit-transition: -webkit-transform 0.15s ease-in-out;
  transition: -webkit-transform 0.15s ease-in-out;
  transition: transform 0.15s ease-in-out;
  transition: transform 0.15s ease-in-out, -webkit-transform 0.15s ease-in-out;
}
.mint-tab-container-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.more-customer-case-container {
  padding-bottom: 3.888889rem;
}
.ai-link-btn {
  border: 1px solid #e1e1e1;
  border-radius: 2.777778rem;
  background-color: #fff;
  color: #000;
  font-size: 1.083333rem;
}
.ai-link-btn:active:after {
  border-radius: 2.777778rem;
}
a {
  position: relative;
}
a:active:after {
  content: '';
  z-index: 9;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.03);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.hair-line-border:after,
.hair-line-top:after {
  content: '';
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  width: 200%;
  height: 200%;
  border: 1px solid #e1e1e1;
  -webkit-transform: scale(0.5) translateZ(0);
  transform: scale(0.5) translateZ(0);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}
.hair-line-top:after {
  border-width: 1px 0 0;
}
.hair-line-bottom:after {
  border: 1px solid #e1e1e1;
  border-width: 0 0 1px;
}
.hair-line-bottom:after,
.hair-line-left-right-top:after {
  content: '';
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  width: 200%;
  height: 200%;
  -webkit-transform: scale(0.5) translateZ(0);
  transform: scale(0.5) translateZ(0);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}
.hair-line-left-right-top:after {
  border: 1px solid #e1e1e1;
  border-width: 1px 1px 0;
}
.hair-line-top-left:after {
  border: 1px solid #e1e1e1;
  border-width: 1px 0 0 1px;
}
.hair-line-right-bottom:after,
.hair-line-top-left:after {
  content: '';
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  width: 200%;
  height: 200%;
  -webkit-transform: scale(0.5) translateZ(0);
  transform: scale(0.5) translateZ(0);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}
.hair-line-right-bottom:after {
  border: 1px solid #e1e1e1;
  border-width: 0 1px 1px 0;
}
.banner-wrapper {
  width: 100%;
  height: 100%;
}
.ai-swipe {
  height: 21.666rem;
  margin: 5.333rem -1.33rem 0;
}
.ai-swipe-inner {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: 50%;
}
.ai-heading.home-heading {
  padding-top: 60px;
}
.ai-section {
  padding: 0 1.33rem;
}
.ai-section-dark {
  background-color: #f6f6f6;
}
.ai-section-last {
  padding-bottom: 0;
}
.ai-section-gradient {
  background-image: linear-gradient(-115deg, #00000b, #182033 85%);
}
.ai-section.p-b-md {
  padding-bottom: 20px;
}
.ai-section.p-b-none {
  padding-bottom: 0;
}
.ai-section.p-t-md {
  padding-top: 20px;
}
.ai-section.p-b-lg {
  padding-bottom: 70px;
}
.ai-heading-solutions {
  letter-spacing: 0.5rem;
}
.ai-news-view-more {
  display: block;
  width: 100%;
  padding: 1.667rem 0 5rem;
  position: relative;
  text-align: center;
}
.ai-news-view-more-btn {
  display: inline-block;
  width: 10rem;
  height: 3rem;
  line-height: 3rem;
  font-size: 1.083rem;
  color: #333;
  text-align: center;
  overflow: hidden;
  position: relative;
}
.ai-news-view-more-btn:after {
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  width: 200%;
  height: 200%;
  border: 1px solid #333;
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.ai-home-anchor {
  position: absolute;
  top: -50px;
  width: 100%;
  height: 50px;
}
.mint-tab-container {
  margin: 0 -1.33rem;
}
.home-tab-nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.home-tab-nav-item {
  padding: 0 0.138889rem;
  margin-left: 1.25rem;
  font-size: 1.25rem;
  color: #fff;
}
.home-tab-nav-item-active {
  font-weight: 700;
}
.ai-home-subtitle {
  margin-bottom: 1.666rem;
  letter-spacing: 0.277rem;
  font-size: 1rem;
  color: #999;
  text-align: center;
}
.ai-tab-bar {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0 -1.33rem;
}
.ai-tab-bar:before {
  content: '';
  position: absolute;
  bottom: -0.6rem;
  left: 0;
  right: 0;
  height: 0.5rem;
  opacity: 0.6;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#eee),
    to(#fff)
  );
  background-image: linear-gradient(#eee, #fff);
}
.tab-top-line:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 200%;
  height: 1px;
  -webkit-transform: scale(0.5) translateZ(0);
  transform: scale(0.5) translateZ(0);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  background: #e1e1e1;
}

.homeBanner {
  position: absolute;
  top: 50%;
  /* transform: translateY(-50%); */
  left: 50%;
  transform: translate(-50%, -50%);
}

.el-container {
  flex-direction: column !important;
}
.containers {
  width: 70%;
  margin: 0 auto;
}
top-nav {
  width: 100%;
}
#products {
  padding-top: 40px;
  padding-bottom: 60px;
}

@media screen and (min-width: 900px) {
  #products {
    height: 580px;
  }
}
#contact {
  padding-top: 40px;
  padding-bottom: 60px;
}
.myp {
  width: 66.66666666666666%;
  margin: 0 auto;
}
.mb40 {
  margin-bottom: 40px;
}
hr {
  background-image: -webkit-linear-gradient(left, #fff, #e6e6e6, #fff);
  height: 2px;
}
.Fast {
  animation: pulse 1s ease-in;
}
.rollIn {
  animation: rollIn 1s;
}
.slideInRight {
  animation: slideInRight 1s;
}
.bounceInLeft {
  animation: bounceInLeft 2s ease-in;
}
.bounceInRight {
  animation: bounceInRight 2s ease-in;
}

.card {
  border: 0 !important;
}
.w40 {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.w40:hover {
  background: #34b1c7;
  padding: 10px 0px;
  color: white;
}
.w40 > img {
  height: 100px;
  width: auto;
}
.psR {
  position: relative;
}
.psR .card-body {
  padding: 0;
  position: absolute;
  bottom: 0;
  width: 100%;
  color: white;
}
.psA {
  background: rgba(0, 0, 0, 0.25);
  width: 100%;
  padding: 20px 0;
}
.fixedBg {
  padding-top: 40px;
  background: url(../../public/img/bg.png) no-repeat center center fixed;
  padding: 60px 0;
  text-align: center;
  background-size: cover;
  background: #45bed1;
}
#solution {
  color: white;
}
.h-650 {
  height: 650px;
}
header {
  width: 100%;
  /* min-height: 650px;
  height: 650px; */
}
a {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}
#headerwrap {
  /* background: url(../../public/img/header_bg.jpg) repeat-x center top; */
  padding-top: 0;
  text-align: center;
  background-attachment: relative;
  background-position: center center;
  min-height: 650px;
  width: 100%;
  -webkit-background-size: 100%;
  -moz-background-size: 100%;
  -o-background-size: 100%;
  background-size: 100%;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  padding-bottom: 0;
  /* margin-top: 60px; */
  display: flex;
  align-items: center;
  justify-content: center;
}
#headerwrap h1 {
  color: #fff;
  font-size: 50px;
  font-weight: 400;
  text-align: center;
  letter-spacing: 2px;
  padding-bottom: 10px;
}
#headerwrap h2 {
  font-size: 30px;
  color: white;
}

#headerwrap .btn {
  font-weight: 500;
  font-size: 17px;
  margin: 20px 0;
  background-color: rgba(255, 255, 255, 0);
  color: #fff;
  border: 1px solid #fff;
}

#headerwrap .btn:hover,
#headerwrap .btn:focus {
  color: #555;
  background-color: #fff;
  outline: 0px;
  border: 1px solid #fff;
}

.aim-item {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  transition: 0.3s;
}
.aim-item-img-warp {
  position: relative;
  width: 100%;
  height: 158px;
}
.aim-item-img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 117px;
  height: 88px;
}
.aim-item-title {
  width: 220px;
  margin: 0 auto;
  line-height: 24px;
  font-size: 16px;
  color: #000;
  text-align: center;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.aim-item-subtitle {
  margin: 10px 0 0;
  font-weight: 400;
  text-align: center;
  font-size: 0;
}
.aim-item-subtitle-text {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: #999;
  line-height: 20px;
  text-align: center;
}
.aim-item-price {
  margin-top: 10px;
  text-align: center;
}
.aim-item-price-currency {
  color: #ff3912;
  font-size: 16px;
}
.aim-item-price-num {
  font-size: 20px;
  color: #ff3912;
  line-height: 24px;
  font-weight: 600;
}
.aim-item-price-original,
.aim-item-price-unit {
  font-size: 14px;
  color: #999;
  line-height: 20px;
}
.aim-item-price-original {
  text-decoration: line-through;
  padding-left: 8px;
}
.aim-item-bar {
  position: absolute;
  width: 100%;
  height: 41px;
  left: 0;
  bottom: -41px;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  transition: 0.3s;
}
.aim-item-bar-detail,
.aim-item-bar-similar {
  display: block;
  width: 50%;
  float: left;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}
.aim-item-bar-detail {
  line-height: 41px;
  color: #fff;
  background-color: #f14000;
  background-image: -webkit-linear-gradient(225deg, #ff7c3f, #f14000);
  background-image: -moz-linear-gradient(225deg, #ff7c3f, #f14000);
  background-image: linear-gradient(225deg, #ff7c3f, #f14000);
}
.aim-item-bar-similar {
  line-height: 39px;
  color: #ff3912;
  background: #fff;
  border: 1px solid #ff7a3d;
  border-left: none;
}
.style1,
.style2 {
  cursor: pointer;
}
.style1:hover .aim-item-bar {
  bottom: 0;
}
.style2 {
  overflow: hidden;
  position: relative;
  padding: 24px 30px;
  width: 100%;
  -webkit-transition: 0.3s;
  -moz-transition: 0.3s;
  transition: 0.3s;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  height: 50%;
}
.style2:first-child {
  border-bottom: 1px solid #dadcdf;
}
.style2:hover .aim-item-bar {
  bottom: 0;
}
.style2 .aim-item-title {
  width: 100%;
  text-align: left;
}
.style2 .aim-item-price,
.style2 .aim-item-subtitle {
  text-align: left;
}
.skeleton .line1 {
  margin: 20px auto 0;
  width: 178px;
  height: 130px;
  background: #f7f7f7;
}
.skeleton .line2 {
  margin: 26px auto 0;
  width: 200px;
  height: 26px;
  background: #f7f7f7;
}
.skeleton .line3 {
  margin: 20px auto 0;
  width: 124px;
  height: 24px;
  background: #f7f7f7;
}
.aim-list {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  border: 1px solid #dadcdf;
  border-bottom: none;
  overflow: hidden;
  margin-top: 40px;
}
.aim-list-item {
  float: left;
  width: 25%;
  height: 270px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border-right: 1px solid #dadcdf;
  border-bottom: 1px solid #dadcdf;
}
.aim-list-item:nth-child(4n + 0) {
  border-right: none;
}
.aim-list-item .aim-item .style2:hover,
.aim-list-item .aim-item:hover {
  -webkit-box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.05);
}
.el-fade-in-enter,
.el-fade-in-leave-active,
.el-fade-in-linear-enter,
.el-fade-in-linear-leave,
.el-fade-in-linear-leave-active,
.fade-in-linear-enter,
.fade-in-linear-leave,
.fade-in-linear-leave-active {
  opacity: 0;
}
.el-fade-in-linear-enter-active,
.el-fade-in-linear-leave-active,
.fade-in-linear-enter-active,
.fade-in-linear-leave-active {
  -webkit-transition: opacity 0.2s linear;
  -moz-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
}
.el-fade-in-enter-active,
.el-fade-in-leave-active,
.el-zoom-in-center-enter-active,
.el-zoom-in-center-leave-active {
  -webkit-transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
  -moz-transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
  transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
}
.el-zoom-in-center-enter,
.el-zoom-in-center-leave-active {
  opacity: 0;
  -webkit-transform: scaleX(0);
  -moz-transform: scaleX(0);
  -ms-transform: scaleX(0);
  transform: scaleX(0);
}
.el-zoom-in-top-enter-active,
.el-zoom-in-top-leave-active {
  opacity: 1;
  -webkit-transform: scaleY(1);
  -moz-transform: scaleY(1);
  -ms-transform: scaleY(1);
  transform: scaleY(1);
  -webkit-transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  -moz-transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -moz-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -moz-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  -webkit-transform-origin: center top;
  -moz-transform-origin: center top;
  -ms-transform-origin: center top;
  transform-origin: center top;
}
.el-zoom-in-top-enter,
.el-zoom-in-top-leave-active {
  opacity: 0;
  -webkit-transform: scaleY(0);
  -moz-transform: scaleY(0);
  -ms-transform: scaleY(0);
  transform: scaleY(0);
}
.el-zoom-in-bottom-enter-active,
.el-zoom-in-bottom-leave-active {
  opacity: 1;
  -webkit-transform: scaleY(1);
  -moz-transform: scaleY(1);
  -ms-transform: scaleY(1);
  transform: scaleY(1);
  -webkit-transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  -moz-transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -moz-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -moz-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  -webkit-transform-origin: center bottom;
  -moz-transform-origin: center bottom;
  -ms-transform-origin: center bottom;
  transform-origin: center bottom;
}
.el-zoom-in-bottom-enter,
.el-zoom-in-bottom-leave-active {
  opacity: 0;
  -webkit-transform: scaleY(0);
  -moz-transform: scaleY(0);
  -ms-transform: scaleY(0);
  transform: scaleY(0);
}
.el-zoom-in-left-enter-active,
.el-zoom-in-left-leave-active {
  opacity: 1;
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
  -webkit-transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  -moz-transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -moz-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -moz-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  -webkit-transform-origin: top left;
  -moz-transform-origin: top left;
  -ms-transform-origin: top left;
  transform-origin: top left;
}
.el-zoom-in-left-enter,
.el-zoom-in-left-leave-active {
  opacity: 0;
  -webkit-transform: scale(0.45);
  -moz-transform: scale(0.45);
  -ms-transform: scale(0.45);
  transform: scale(0.45);
}
.collapse-transition {
  -webkit-transition: height 0.3s ease-in-out, padding-top 0.3s ease-in-out,
    padding-bottom 0.3s ease-in-out;
  -moz-transition: 0.3s height ease-in-out, 0.3s padding-top ease-in-out,
    0.3s padding-bottom ease-in-out;
  transition: height 0.3s ease-in-out, padding-top 0.3s ease-in-out,
    padding-bottom 0.3s ease-in-out;
}
.horizontal-collapse-transition {
  -webkit-transition: width 0.3s ease-in-out, padding-left 0.3s ease-in-out,
    padding-right 0.3s ease-in-out;
  -moz-transition: 0.3s width ease-in-out, 0.3s padding-left ease-in-out,
    0.3s padding-right ease-in-out;
  transition: width 0.3s ease-in-out, padding-left 0.3s ease-in-out,
    padding-right 0.3s ease-in-out;
}
.el-list-enter-active,
.el-list-leave-active {
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  transition: all 1s;
}
.el-list-enter,
.el-list-leave-active {
  opacity: 0;
  -webkit-transform: translateY(-30px);
  -moz-transform: translateY(-30px);
  -ms-transform: translateY(-30px);
  transform: translateY(-30px);
}
.el-opacity-transition {
  -webkit-transition: opacity 0.3s cubic-bezier(0.55, 0, 0.1, 1);
  -moz-transition: opacity 0.3s cubic-bezier(0.55, 0, 0.1, 1);
  transition: opacity 0.3s cubic-bezier(0.55, 0, 0.1, 1);
}
@font-face {
  font-family: element-icons;
  src: url(//aip.bdstatic.com/portal-pc-node/dist/1579591791591/fonts/element-icons.woff)
      format('woff'),
    url(//aip.bdstatic.com/portal-pc-node/dist/1579591791591/fonts/element-icons.ttf)
      format('truetype');
  font-weight: 400;
  font-style: normal;
}
[class*=' el-icon-'],
[class^='el-icon-'] {
  font-family: element-icons !important;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-icon-info:before {
  content: '\e61a';
}
.el-icon-error:before {
  content: '\e62c';
}
.el-icon-success:before {
  content: '\e62d';
}
.el-icon-warning:before {
  content: '\e62e';
}
.el-icon-question:before {
  content: '\e634';
}
.el-icon-back:before {
  content: '\e606';
}
.el-icon-arrow-left:before {
  content: '\e600';
}
.el-icon-arrow-down:before {
  content: '\e603';
}
.el-icon-arrow-right:before {
  content: '\e604';
}
.el-icon-arrow-up:before {
  content: '\e605';
}
.el-icon-caret-left:before {
  content: '\e60a';
}
.el-icon-caret-bottom:before {
  content: '\e60b';
}
.el-icon-caret-top:before {
  content: '\e60c';
}
.el-icon-caret-right:before {
  content: '\e60e';
}
.el-icon-d-arrow-left:before {
  content: '\e610';
}
.el-icon-d-arrow-right:before {
  content: '\e613';
}
.el-icon-minus:before {
  content: '\e621';
}
.el-icon-plus:before {
  content: '\e62b';
}
.el-icon-remove:before {
  content: '\e635';
}
.el-icon-circle-plus:before {
  content: '\e601';
}
.el-icon-remove-outline:before {
  content: '\e63c';
}
.el-icon-circle-plus-outline:before {
  content: '\e602';
}
.el-icon-close:before {
  content: '\e60f';
}
.el-icon-check:before {
  content: '\e611';
}
.el-icon-circle-close:before {
  content: '\e607';
}
.el-icon-circle-check:before {
  content: '\e639';
}
.el-icon-circle-close-outline:before {
  content: '\e609';
}
.el-icon-circle-check-outline:before {
  content: '\e63e';
}
.el-icon-zoom-out:before {
  content: '\e645';
}
.el-icon-zoom-in:before {
  content: '\e641';
}
.el-icon-d-caret:before {
  content: '\e615';
}
.el-icon-sort:before {
  content: '\e640';
}
.el-icon-sort-down:before {
  content: '\e630';
}
.el-icon-sort-up:before {
  content: '\e631';
}
.el-icon-tickets:before {
  content: '\e63f';
}
.el-icon-document:before {
  content: '\e614';
}
.el-icon-goods:before {
  content: '\e618';
}
.el-icon-sold-out:before {
  content: '\e63b';
}
.el-icon-news:before {
  content: '\e625';
}
.el-icon-message:before {
  content: '\e61b';
}
.el-icon-date:before {
  content: '\e608';
}
.el-icon-printer:before {
  content: '\e62f';
}
.el-icon-time:before {
  content: '\e642';
}
.el-icon-bell:before {
  content: '\e622';
}
.el-icon-mobile-phone:before {
  content: '\e624';
}
.el-icon-service:before {
  content: '\e63a';
}
.el-icon-view:before {
  content: '\e643';
}
.el-icon-menu:before {
  content: '\e620';
}
.el-icon-more:before {
  content: '\e646';
}
.el-icon-more-outline:before {
  content: '\e626';
}
.el-icon-star-on:before {
  content: '\e637';
}
.el-icon-star-off:before {
  content: '\e63d';
}
.el-icon-location:before {
  content: '\e61d';
}
.el-icon-location-outline:before {
  content: '\e61f';
}
.el-icon-phone:before {
  content: '\e627';
}
.el-icon-phone-outline:before {
  content: '\e628';
}
.el-icon-picture:before {
  content: '\e629';
}
.el-icon-picture-outline:before {
  content: '\e62a';
}
.el-icon-delete:before {
  content: '\e612';
}
.el-icon-search:before {
  content: '\e619';
}
.el-icon-edit:before {
  content: '\e61c';
}
.el-icon-edit-outline:before {
  content: '\e616';
}
.el-icon-rank:before {
  content: '\e632';
}
.el-icon-refresh:before {
  content: '\e633';
}
.el-icon-share:before {
  content: '\e636';
}
.el-icon-setting:before {
  content: '\e638';
}
.el-icon-upload:before {
  content: '\e60d';
}
.el-icon-upload2:before {
  content: '\e644';
}
.el-icon-download:before {
  content: '\e617';
}
.el-icon-loading:before {
  content: '\e61e';
}
.el-icon-loading {
  -webkit-animation: rotating 2s linear infinite;
  -moz-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite;
}
.el-icon--right {
  margin-left: 5px;
}
.el-icon--left {
  margin-right: 5px;
}
@-webkit-keyframes rotating {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
@-moz-keyframes rotating {
  0% {
    -webkit-transform: rotate(0);
    -moz-transform: rotate(0);
    transform: rotate(0);
  }
  to {
    -webkit-transform: rotate(1turn);
    -moz-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
@keyframes rotating {
  0% {
    -webkit-transform: rotate(0);
    -moz-transform: rotate(0);
    transform: rotate(0);
  }
  to {
    -webkit-transform: rotate(1turn);
    -moz-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
.ai-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  color: #fff;
  background-color: #000;
  overflow: auto;
  font-weight: 700;
}
.ai-nav-bar {
  position: relative;
  width: 100%;
  height: 60px;
  line-height: 60px;
  padding: 0 30px;
  z-index: 1;
  min-width: 1200px;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.ai-nav-bar-inner {
  height: 100%;
  margin-left: 200px;
  font-size: 16px;
}
.ai-nav-logo {
  float: left;
  width: 176px;
  height: 100%;
  line-height: normal;
}
.ai-nav-logo-icon {
  width: 100%;
  height: 24px;
  margin-top: 14px;
  fill: #fff;
}
.ai-nav-operation {
  position: absolute;
  right: 30px;
  top: 0;
  height: 100%;
}
.ai-nav-operation a {
  margin-left: 40px;
  color: inherit;
  font-size: 14px;
}
.ai-nav-operation a:hover {
  color: #3b85f5;
}
.ai-nav-item {
  position: relative;
  display: inline-block;
  overflow: hidden;
  width: 80px;
  height: 100%;
  padding: 0 15px;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  -webkit-transition: color 0.3s;
  -moz-transition: color 0.3s;
  transition: color 0.3s;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
}
.ai-nav-item-active,
.ai-nav-item:hover {
  color: #3b85f5;
}
.ai-nav-name {
  display: block;
  color: inherit;
  font-weight: 700;
}
.ai-nav-detail {
  display: none;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 60px;
  border: 1px solid #dfdfdf;
  border-top: 0;
  overflow: hidden;
  min-height: 310px;
  max-height: 768px;
  background: #fff;
  -webkit-box-shadow: 0 5px 6px -2px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: 0 5px 6px -2px rgba(0, 0, 0, 0.19);
  box-shadow: 0 5px 6px -2px rgba(0, 0, 0, 0.19);
  z-index: 999;
}
.ai-nav-detail-hasMore {
  padding-bottom: 50px;
}
.ai-nav-detail-inner {
  position: relative;
  min-width: 970px;
  height: 100%;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.ai-nav-detail-small {
  max-height: 288px;
}
.ai-nav-detail-more {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-top: 1px solid #dfdfdf;
  background: #fff;
}
.ai-nav-detail-more a {
  color: #000;
  font-size: 14px;
}
.ai-nav-detail-more a:hover {
  color: #1a73e8;
}
.ai-nav-detail-more a:hover .ai-nav-menu-arrow-icon {
  fill: #1a73e8;
}
.ai-nav-active,
.ai-nav-active > .ai-nav-menu {
  display: block;
}
.ai-nav-active > .ai-nav-sidebar-item-title-inner,
.ai-nav-active > .ai-nav-sidebar-list-item-title {
  color: #1a73e8;
}
.ai-nav-sidebar {
  height: 100%;
  overflow: hidden;
  float: left;
  width: 270px;
  text-align: left;
  padding: 18px 0;
  line-height: 30px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 14px;
}
.ai-nav-sidebar-inner {
  height: 100%;
  overflow-y: auto;
}
.ai-nav-sidebar-list-item {
  margin: 8px 0;
  cursor: pointer;
}
.ai-nav-sidebar-list-item-title {
  position: relative;
  padding-left: 38%;
}
.ai-nav-sidebar-list-item-title:hover {
  background: #f7f7f7;
}
.ai-nav-sidebar-item-title {
  padding-left: 38%;
  margin: 8px 0;
  font-weight: 700;
  color: #000;
  cursor: default;
}
.ai-nav-sidebar-item-title-hasMenu:hover {
  background: #f7f7f7;
  color: #1a73e8;
}
.ai-nav-sidebar-item-title-inner {
  position: relative;
}
.ai-nav-sidebar-arrow-icon {
  position: absolute;
  right: 22px;
  top: 10px;
  width: 6px;
  height: 11px;
  fill: #1a73e8;
}
.ai-nav-sidebar .ai-nav-menu {
  min-height: 100%;
  border-left: 1px solid #dfe0e3;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.ai-nav-menu {
  line-height: 30px;
  text-align: left;
  height: 100%;
  overflow-y: auto;
}
.ai-nav-menu-inner {
  display: table;
  width: 100%;
  height: 100%;
}
.ai-nav-menu-has-sidebar {
  border-left: 1px solid #dfe0e3;
}
.ai-nav-menu-col {
  float: left;
  margin-top: -15px;
  padding: 0 20px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.ai-nav-menu-col-3 {
  width: 33.333%;
}
.ai-nav-menu-col-4 {
  width: 25%;
}
.ai-nav-menu-col-5 {
  width: 20%;
}
.ai-nav-menu-item {
  margin-top: 15px;
}
.ai-nav-menu-item,
.ai-nav-menu-item-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ai-nav-menu-item-title {
  position: relative;
  display: block;
  padding: 0 0 7px 10px;
  color: #000;
  font-size: 16px;
  font-weight: 700;
}
.ai-nav-menu-item-title:after {
  content: '';
  position: absolute;
  left: 10px;
  right: 0;
  bottom: 0;
  height: 1px;
  background: #dfe0e3;
}
.ai-nav-menu-item-title-link:hover {
  color: #1a73e8;
}
.ai-nav-menu-item-title-link:hover .ai-nav-menu-arrow-icon {
  fill: #1a73e8;
}
.ai-nav-menu-item-list {
  margin-top: 12px;
}
.ai-nav-menu-item-list-empty {
  margin-top: 8px;
}
.ai-nav-menu-item-list-item {
  display: block;
  padding-left: 10px;
  font-size: 14px;
  color: #333;
  font-weight: 400;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ai-nav-menu-item-list-item:hover {
  color: #1a73e8;
  background: #f7f7f7;
}
.ai-nav-menu-common {
  display: table-cell;
  padding: 26px 0 18px;
  overflow: hidden;
}
.ai-nav-menu-activity {
  display: table-cell;
  vertical-align: top;
  width: 310px;
  padding: 0 30px 30px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: #fafafa;
}
.ai-nav-menu-activity-item {
  margin-top: 26px;
}
.ai-nav-menu-activity-title {
  position: relative;
  padding: 0 0 7px 10px;
  border-bottom: 1px solid #dfe0e3;
  font-size: 16px;
  color: #000;
  font-weight: 700;
}
.ai-nav-menu-activity-title:before {
  content: '';
  position: absolute;
  left: 0;
  top: 8px;
  width: 2px;
  height: 14px;
  background: #000;
}
.ai-nav-menu-activity-list {
  margin-top: 12px;
}
.ai-nav-menu-arrow-icon {
  width: 6px;
  height: 11px;
  margin-left: 8px;
}
.ai-nav-menu-tag {
  font-size: 12px;
  margin-left: 6px;
}
.ai-nav-menu-tag-new {
  color: #1a73e8;
}
.ai-nav-menu-tag-hot {
  color: #ff3912;
}
.ai-nav-menu-tag-test {
  color: #00b359;
}
@media (max-width: 970px) {
  .ai-nav-sidebar {
    width: 218px;
  }
  .ai-nav-menu-has-sidebar {
    margin-left: 218px;
  }
  .ai-nav-menu-activity {
    width: 226px;
  }
  .ai-nav-menu-has-activity .ai-nav-menu-common {
    margin-right: 226px;
  }
}
@media (min-width: 971px) and (max-width: 1440px) {
  .ai-nav-sidebar {
    width: 250px;
  }
  .ai-nav-menu-has-sidebar {
    margin-left: 250px;
  }
  .ai-nav-menu-activity {
    width: 256px;
  }
  .ai-nav-menu-has-activity .ai-nav-menu-common {
    margin-right: 256px;
  }
}
@media (min-width: 1441px) {
  .ai-nav-sidebar {
    width: 270px;
  }
  .ai-nav-menu-has-sidebar {
    margin-left: 270px;
  }
  .ai-nav-menu-activity {
    width: 310px;
  }
  .ai-nav-menu-has-activity .ai-nav-menu-common {
    margin-right: 310px;
  }
}
.ai-platform-mask {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
}
.ai-footer {
  position: relative;
  z-index: 2;
  height: 480px;
  background-color: #010101;
  font-size: 0;
}
.ai-footer .ai-footer-cover {
  width: 1200px;
  height: 371px;
  margin: 0 auto;
}
.ai-footer .ai-footer-items {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  height: 100%;
  width: 1000px;
  display: inline-block;
  vertical-align: top;
  padding-left: 49px;
}
.ai-footer .ai-item-class {
  display: inline-block;
  vertical-align: top;
  width: 194px;
  text-align: left;
  font-size: 18px;
  color: #fff;
}
.ai-footer .ai-last-class {
  width: 174px;
}
.ai-footer .ai-items {
  font-size: 14px;
  color: #fff;
  opacity: 0.66;
  line-height: 36px;
  cursor: pointer;
}
.ai-footer .ai-items:hover {
  opacity: 1;
  color: #036fe2;
}
.ai-footer .ai-telephone {
  font-size: 14px;
  color: #fff;
  opacity: 0.66;
  line-height: 36px;
}
.ai-footer .ai-title {
  margin: 61px 0 14px;
  color: #fff;
  font-size: 16px;
  opacity: 1;
  cursor: default;
  line-height: 36px;
}
.ai-footer .ai-items-img {
  display: inline-block;
  vertical-align: top;
  padding-top: 184px;
  color: #b1b1b1;
  font-size: 14px;
  width: 168px;
  height: 24px;
  text-align: center;
  margin-top: 61px;
  background: url(//aip.bdstatic.com/portal-pc-node/dist/1579591791591/images/qr.png)
    no-repeat;
  -moz-background-size: 168px 168px;
  background-size: 168px 168px;
}
.ai-footer .ai-footer-baseline-contain {
  background-color: #000;
  height: 50px;
}
.ai-footer .ai-footer-baseline {
  width: 1200px;
  text-align: left;
  margin: 59px auto 0;
  font-size: 0;
  line-height: 50px;
}
.ai-footer .ai-footer-baseline .ai-baseline-info {
  display: inline-block;
  padding: 0 10px;
  vertical-align: top;
  font-size: 14px;
  opacity: 0.5;
  color: #fff;
}
.ai-footer .ai-footer-baseline .ai-baseline-info:hover {
  opacity: 1;
  color: #036fe2;
}
.ai-footer .ai-footer-baseline .ai-baseline-info-divider {
  display: inline-block;
  vertical-align: top;
  font-size: 10px;
  color: #fff;
  opacity: 0.5;
}
.ai-footer .ai-footer-baseline .ai-info-add {
  border: 0;
  padding-right: 74px;
}
.ai-footer .ai-footer-baseline .ai-info-read {
  border: 0;
  float: right;
  padding-right: 32px;
}
.ai-footer .ai-first-baseline {
  display: inline-block;
  margin-left: 40px;
  padding: 0 10px;
  vertical-align: top;
  font-size: 14px;
  opacity: 0.5;
  color: #fff;
}
.ai-footer .ai-qq-group {
  font-family: PingFangSC-Medium;
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 892px;
  padding: 50px 82px;
  z-index: 30000;
  background-color: #fff;
  font-size: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #ccc;
  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
}
.ai-footer .ai-qq-group .ai-qq-group-title {
  margin-bottom: 52px;
  font-size: 28px;
  text-align: center;
}
.ai-footer .ai-qq-group .ai-qq-group-column {
  margin-bottom: -40px;
  font-size: 0;
}
.ai-footer .ai-qq-group .ai-qq-group-item {
  display: inline-block;
  vertical-align: top;
  margin-bottom: 40px;
  width: 242px;
  font-size: 16px;
}
.ai-footer .ai-qq-group .ai-qq-number {
  font-family: PingFangSC-Regular;
}
.ai-footer .ai-qq-group .ai-hide-group {
  position: absolute;
  top: 39px;
  right: 20px;
  width: 45px;
  height: 45px;
  font-size: 45px;
  color: #999;
  cursor: pointer;
}
.ai-hide-mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
}
.ai-aside {
  position: fixed;
  width: 50px;
  right: 10px;
  top: 70%;
  -webkit-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;
  color: #000;
  z-index: 998;
}
.ai-aside-icon {
  fill: #000;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.ai-aside-icon-qm {
  width: 24px;
  height: 24px;
}
.ai-aside-icon-consult {
  width: 24px;
  height: 18px;
}
.ai-aside-icon-back {
  width: 17px;
  height: 17px;
}
.ai-aside-item {
  width: 100%;
  height: 58px;
  position: relative;
  cursor: pointer;
}
.ai-aside-item:hover .ai-aside-inner,
.ai-aside-item:hover .ai-aside-text {
  display: block;
}
.ai-aside-inner {
  display: none;
  position: absolute;
  right: 70px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  padding: 10px 6px 6px;
  background-color: #fff;
  color: #000;
  text-align: center;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  -webkit-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
}
.ai-aside-inner-title {
  margin-bottom: 8px;
  font-size: 14px;
}
.ai-aside-inner-sub {
  margin-bottom: 10px;
  font-size: 12px;
}
.ai-aside-inner-img {
  width: 147px;
  height: 147px;
  background: url(//aip.bdstatic.com/portal-pc-node/dist/1579591791591/images/home/code.jpg)
    no-repeat 50%;
  -moz-background-size: 147px 147px;
  background-size: 147px 147px;
}
.ai-aside-inner-triangle {
  position: absolute;
  right: -10px;
  top: 50%;
  -webkit-transform: rotate(-45deg) translateY(-50%);
  -moz-transform: rotate(-45deg) translateY(-50%);
  -ms-transform: rotate(-45deg) translateY(-50%);
  transform: rotate(-45deg) translateY(-50%);
  width: 12px;
  height: 12px;
  border-color: transparent #fff #fff transparent;
  border-style: solid;
  border-width: 6px;
  background: transparent;
  -webkit-box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.1);
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.ai-aside-text {
  display: none;
  position: absolute;
  width: 30px;
  height: 32px;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  color: #000;
  line-height: 16px;
  font-size: 13px;
  padding: 13px 10px;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  text-align: center;
  background-color: #f7f7f7;
}
@font-face {
  font-family: ai-icons;
  font-weight: 400;
  font-style: normal;
  src: url(//aip.bdstatic.com/portal-pc-node/dist/1579591791591/fonts/ai-icons.eot);
  src: url(//aip.bdstatic.com/portal-pc-node/dist/1579591791591/fonts/ai-icons.eot#iefix)
      format('embedded-opentype'),
    url(//aip.bdstatic.com/portal-pc-node/dist/1579591791591/fonts/ai-icons.ttf)
      format('truetype'),
    url(//aip.bdstatic.com/portal-pc-node/dist/1579591791591/fonts/ai-icons.woff)
      format('woff'),
    url([object\Module]#ai-icons) format('svg');
}
[class*=' ai-icon-'],
[class^='ai-icon-'] {
  font-family: ai-icons !important;
  font-weight: 400;
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  speak: none;
}
.ai-icon-text:before {
  content: '\e922';
}
.ai-icon-more:before {
  content: '\e900';
}
.ai-icon-close-circle-fill:before {
  content: '\e901';
}
.ai-icon-close-circle:before {
  content: '\e902';
}
.ai-icon-question-square:before {
  content: '\e903';
}
.ai-icon-question-square-fill:before {
  content: '\e904';
}
.ai-icon-check-circle:before {
  content: '\e905';
}
.ai-icon-warning-circle:before {
  content: '\e906';
}
.ai-icon-body:before {
  content: '\e907';
}
.ai-icon-ar:before {
  content: '\e908';
}
.ai-icon-speech:before {
  content: '\e909';
}
.ai-icon-data:before {
  content: '\e90a';
}
.ai-icon-easydl:before {
  content: '\e90b';
}
.ai-icon-hardware:before {
  content: '\e90c';
}
.ai-icon-image:before {
  content: '\e90d';
}
.ai-icon-nlp:before {
  content: '\e90e';
}
.ai-icon-paddle:before {
  content: '\e90f';
}
.ai-icon-schema:before {
  content: '\e910';
}
.ai-icon-solution:before {
  content: '\e911';
}
.ai-icon-video:before {
  content: '\e912';
}
.ai-icon-search:before {
  content: '\e913';
}
.ai-icon-forum:before {
  content: '\e914';
}
.ai-icon-video2:before {
  content: '\e915';
}
.ai-icon-github:before {
  content: '\e916';
}
.ai-icon-sdk:before {
  content: '\e917';
}
.ai-icon-arrow:before {
  content: '\e918';
}
.ai-icon-close:before {
  content: '\e919';
}
.ai-icon-copy:before {
  content: '\e91a';
}
.ai-icon-feedback:before {
  content: '\e91b';
}
.ai-icon-smile:before {
  content: '\e91c';
}
.ai-icon-smarty:before {
  content: '\e91d';
}
.ai-icon-video-big:before {
  content: '\e91e';
}
.ai-icon-play:before {
  content: '\e91f';
}
.ai-icon-download:before {
  content: '\e920';
}
.ai-icon-pause:before {
  content: '\e921';
}
body,
html {
  min-width: 1240px;
  margin: 0;
  font: 14px BlinkMacSystemFont, Roboto, Helvetica Neue, Helvetica,
    PingFangSC-Regular, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
  background-color: #fff;
  -webkit-font-smoothing: antialiased;
}
body .ai-track,
html .ai-track {
  display: none;
}
.ai-content {
  padding-top: 60px;
}
.ai-platform-wrap {
  width: 100%;
  margin: 0 auto;
  position: relative;
  /* padding-bottom: 64px; */
}
.ai-platform-pagination {
  text-align: center;
}
.ai-platform-pagination.el-pagination {
  line-height: 36px;
  padding: 0;
}
.ai-platform-pagination.el-pagination .btn-next,
.ai-platform-pagination.el-pagination .btn-prev {
  width: 36px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  border: 0;
}
.ai-platform-pagination.el-pagination .btn-next:hover,
.ai-platform-pagination.el-pagination .btn-prev:hover {
  -webkit-box-shadow: 0 0 0 #fff;
  -moz-box-shadow: 0 0 0 #fff;
  box-shadow: 0 0 0 #fff;
}
.ai-platform-pagination.el-pagination .btn-next .el-icon,
.ai-platform-pagination.el-pagination .btn-prev .el-icon {
  font-size: 0;
}
.ai-platform-pagination.el-pagination .btn-next:disabled .el-icon:before,
.ai-platform-pagination.el-pagination .btn-prev:disabled .el-icon:before {
  opacity: 0.3;
}
.ai-platform-pagination.el-pagination .el-icon-arrow-left:before,
.ai-platform-pagination.el-pagination .el-icon-arrow-right:before {
  content: '';
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  border-width: 4px;
  border-style: solid;
}
.ai-platform-pagination.el-pagination .el-icon-arrow-left:before {
  border-color: transparent #666 transparent transparent;
}
.ai-platform-pagination.el-pagination .el-icon-arrow-right:before {
  border-color: transparent transparent transparent #666;
}
.ai-platform-pagination.el-pagination .el-pager {
  background: #fff;
  line-height: 36px;
}
.ai-platform-pagination.el-pagination .el-pager .el-icon-more {
  border: 0;
}
.ai-platform-pagination.el-pagination .el-pager .el-icon-more:before {
  content: '...';
}
.ai-platform-pagination.el-pagination .el-pager .el-icon-d-arrow-left,
.ai-platform-pagination.el-pagination .el-pager .el-icon-d-arrow-right {
  border: 0;
}
.ai-platform-pagination.el-pagination .el-pager .el-icon-d-arrow-left:before,
.ai-platform-pagination.el-pagination .el-pager .el-icon-d-arrow-right:before {
  content: '...';
}
.ai-platform-pagination.el-pagination .el-pager .el-icon-d-arrow-left:hover,
.ai-platform-pagination.el-pagination .el-pager .el-icon-d-arrow-right:hover {
  content: '...';
  border: 0;
}
.ai-platform-pagination.el-pagination .el-pager .number {
  display: inline-block;
  vertical-align: top;
  border: 0;
  font-size: 14px;
  min-width: 36px;
  height: 36px;
  line-height: 36px;
  font-weight: 400;
  cursor: pointer;
}
.ai-platform-pagination.el-pagination .active {
  border-color: #fff;
  background: #999;
  color: #fff;
}
.ai-platform a {
  text-decoration: none;
}
.ai-share-icon {
  display: none;
}
.ai-link,
a {
  text-decoration: none;
}
.ai-link:hover {
  color: #036fe2;
  text-decoration: underline;
}
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-track {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  background-color: #ccc;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #989898;
}
.ai-home-banner {
  position: relative;
  width: 100%;
}
.ai-home-banner .fadeIn-leave {
  opacity: 1;
}
.ai-home-banner .fadeIn-leave-active {
  -webkit-transition: opacity 0.2s linear;
  -moz-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
}
.ai-home-banner .fadeIn-enter,
.ai-home-banner .fadeIn-leave-to {
  opacity: 0;
}
.ai-home-banner .fadeIn-enter-active {
  -webkit-transition: opacity 0.6s linear;
  -moz-transition: opacity 0.6s linear;
  transition: opacity 0.6s linear;
}
.ai-home-banner .fadeIn-enter-to {
  opacity: 1;
}
.ai-banner-cover {
  position: relative;
  height: 468px;
  margin: 0 auto;
  overflow: hidden;
  cursor: pointer;
}
.ai-banner-trans {
  position: relative;
  width: 100%;
  height: 100%;
}
.ai-banner-contain {
  -moz-background-size: 1600px 468px;
  background-size: 1600px 468px;
  background-position: top;
  background-repeat: no-repeat;
}
.ai-banner-contain,
.ai-banner-jump {
  position: absolute;
  width: 100%;
  height: 100%;
}
.ai-banner-jump {
  left: 0;
  top: 0;
}
.ai-banner-bar-cover {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 16px;
  padding: 16px 0;
  font-size: 0;
  text-align: center;
}
.ai-banner-bar {
  display: inline-block;
  vertical-align: bottom;
  margin-right: 10px;
  width: 80px;
  height: 4px;
  padding: 8px 0;
  overflow: hidden;
  z-index: 200;
}
.ai-banner-bar-bg {
  width: 100%;
  height: 100%;
  background-color: #d8d8d8;
}
.ai-banner-bar-inner {
  width: 0;
  height: 100%;
  background: #1a73e8;
}
.ai-banner-info {
  width: 500px;
  margin-top: 128px;
  position: relative;
  z-index: 1;
}
.ai-banner-title {
  font-size: 40px;
  line-height: 48px;
  font-weight: 700;
}
.ai-banner-desc {
  margin-top: 22px;
  font-size: 20px;
  line-height: 24px;
}
.ai-banner-bottom {
  margin-top: 43px;
}
.ai-banner-bottom-inner {
  display: inline-block;
}
.ai-banner-bottom-inner:hover .ai-banner-btn {
  display: none;
}
.ai-banner-bottom-inner:hover .ai-banner-btn-hover {
  display: inline-block;
}
.ai-banner-btn,
.ai-banner-btn-hover {
  padding: 0 30px;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.ai-banner-btn {
  border: 1px solid #000;
  display: inline-block;
}
.ai-banner-btn-hover {
  border: 1px solid transparent;
  display: none;
}
.ai-home-news {
  position: relative;
  height: 400px;
}
.ai-home-news:before {
  width: 100%;
  height: 1px;
}
.ai-home-news:after,
.ai-home-news:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  background: #dadcdf;
  z-index: 2;
}
.ai-home-news:after {
  width: 1px;
  height: 100%;
}
.ai-news-activity {
  float: left;
  width: 274px;
  height: 400px;
  border-right: 1px solid #dadcdf;
  border-bottom: 1px solid #dadcdf;
  padding: 68px 45px 68px 35px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -moz-background-size: 100% 100%;
  background-size: 100% 100%;
}
.ai-news-activity-title {
  font-size: 22px;
  color: #000;
  line-height: 30px;
  font-weight: 700;
}
.ai-news-activity-detail {
  margin-top: 20px;
  line-height: 34px;
  font-size: 14px;
  color: #333;
}
.ai-news-activity-btn {
  width: 90px;
  height: 30px;
  margin-top: 20px;
  line-height: 30px;
  text-align: center;
  border: 1px solid #3b4043;
  -webkit-border-radius: 17px;
  -moz-border-radius: 17px;
  border-radius: 17px;
  font-size: 14px;
  font-weight: 700;
  color: #3b4043;
}
.ai-news-activity:hover {
  -webkit-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
}
.ai-news-activity:hover .ai-news-activity-title {
  color: #1a73e8;
}
.ai-news-activity:hover .ai-news-activity-btn {
  border-color: #1a73e8;
  color: #1a73e8;
}
.ai-news-common {
  position: relative;
  float: left;
  width: 302px;
  height: 200px;
  border-right: 1px solid #dadcdf;
  border-bottom: 1px solid #dadcdf;
  padding: 50px 20px 52px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -moz-background-size: cover;
  background-size: cover;
  background-repeat: no-repeat;
}
.ai-news-common-title {
  font-size: 20px;
  line-height: 30px;
  height: 60px;
  color: #1f2024;
  overflow: hidden;
}
.ai-news-common-tag {
  position: absolute;
  left: 20px;
  bottom: 52px;
  font-size: 14px;
  line-height: 14px;
  color: #666;
}
.ai-news-common:hover {
  -webkit-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
  z-index: 1;
}
.ai-news-common:hover .ai-news-common-title {
  color: #1a73e8;
}
.ai-tabs,
.ai-tabs-header {
  position: relative;
}
.ai-tabs-header-line {
  position: absolute;
  -webkit-transition: -webkit-transform 0.8s
    cubic-bezier(0.07, 1.32, 0.62, 0.99);
  transition: -webkit-transform 0.8s cubic-bezier(0.07, 1.32, 0.62, 0.99);
  -moz-transition: transform 0.8s cubic-bezier(0.07, 1.32, 0.62, 0.99),
    -moz-transform 0.8s cubic-bezier(0.07, 1.32, 0.62, 0.99);
  transition: transform 0.8s cubic-bezier(0.07, 1.32, 0.62, 0.99);
  transition: transform 0.8s cubic-bezier(0.07, 1.32, 0.62, 0.99),
    -webkit-transform 0.8s cubic-bezier(0.07, 1.32, 0.62, 0.99),
    -moz-transform 0.8s cubic-bezier(0.07, 1.32, 0.62, 0.99);
  background-color: #000;
  z-index: 1;
}
.ai-tabs-item {
  position: relative;
  color: #666;
  font-size: 20px;
  cursor: pointer;
}
.ai-tabs-item-active {
  font-weight: 700;
  color: #000;
}
.ai-tabs-item-active::after {
  display: block;
  content: '';
  width: 50%;
  left: 50%;
  height: 5px;
  position: absolute;
  top: 58px;
  left: 50%;
  background-color: #000;
  transform: translateX(-50%);
  z-index: 99;
}

.ai-tabs-top .ai-tabs-header {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  text-align: center;
}
.ai-tabs-top .ai-tabs-header-line {
  left: 0;
  bottom: 0;
  width: 80px;
  height: 2px;
}
.ai-tabs-top .ai-tabs-item {
  padding-bottom: 8px;
  margin-left: 34px;
}
.ai-tabs-top .ai-tabs-item:first-child {
  margin-left: 0;
}
.ai-tabs-left .ai-tabs-header {
  /* float: left;a */
  width: 100%;
  padding: 0px 0;
  text-align: center;
  margin-bottom: 60px;
}
.ai-tabs-left .ai-tabs-header-line {
  right: -3px;
  top: 0;
  width: 5px;
  height: 44px;
  background-color: #000;
}
.ai-tabs-left .ai-tabs-item {
  width: 100%;
  height: 44px;
  line-height: 44px;
}
.ai-tabs-left .ai-tabs-item:first-child {
  margin-top: 0;
}
.ai-tabs-left .ai-tabs-pane {
  /* padding-left: 30px; */
  /* margin-left: 150px;1 */
}
.ai-tabs-header:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 1px;
  top: 60px;
  bottom: 0;
  left: 0px;
  background: #dadcdf;
}

.fadeIn-leave {
  opacity: 1;
}
.fadeIn-leave-active {
  -webkit-transition: opacity 0.2s ease-out;
  -moz-transition: opacity 0.2s ease-out;
  transition: opacity 0.2s ease-out;
}
.fadeIn-enter,
.fadeIn-leave-to {
  opacity: 0;
}
.fadeIn-enter-active {
  -webkit-transition: opacity 0.5s ease 0.3s;
  -moz-transition: opacity 0.5s ease 0.3s;
  transition: opacity 0.5s ease 0.3s;
}
.fadeIn-enter-to {
  opacity: 1;
}
.ai-layout-a {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -moz-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.ai-layout-a-item {
  display: block;
  position: relative;
  color: inherit;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.ai-layout-a-item-links a {
  color: inherit;
}
.ai-layout-b {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -moz-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.ai-layout-b-item {
  display: block;
  position: relative;
  width: 280px;
  height: 280px;
  /* padding-top: 44px; */
  border: 1px solid #dadcdf;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  color: inherit;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}
@media screen and (max-width: 400px) {
  .ai-layout-b-item {
    padding-top: 20px;
  }
}
.ai-layout-b-item-title {
  margin-top: 11px;
  font-size: 16px;
  line-height: 26px;
  color: #000;
  font-weight: 700;
  position: relative;
  line-height: 1.5;
}
.ai-layout-b-item-img {
  width: 120px;
  height: 120px;
  background-repeat: no-repeat;
  -moz-background-size: contain;
  background-size: contain;
  margin: 0 auto;
}
.ai-home-section-technique-2 .ai-tabs-item {
  margin-top: 262px;
}
.ai-home-section-technique-3 .ai-tabs-item {
  margin-top: 109px;
}
.ai-home-section-technique-4 .ai-tabs-item {
  margin-top: 58px;
}
.ai-home-section-technique-5 .ai-tabs-item {
  margin-top: 32.5px;
}
.ai-home-section-technique-6 .ai-tabs-item {
  margin-top: 17.2px;
}
.ai-home-section-technique-7 .ai-tabs-item {
  margin-top: 7px;
}
.ai-home-section {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
}
.ai-home-section-title {
  font-size: 34px;
  line-height: 44px;
  text-align: center;
  color: inherit;
}
.ai-home-section-more {
  margin-top: 60px;
  text-align: center;
}
.ai-home-section-more-link {
  font-size: 16px;
  color: #000;
  cursor: pointer;
}
.ai-home-section-part {
  padding-top: 40px;
}
.ai-home-section-part-title {
  font-size: 24px;
  text-align: center;
}
.ai-home-section-part-title-inner {
  position: relative;
}
.ai-home-section-part-title-inner-text {
  position: relative;
  padding: 0 10px;
  background: #fff;
  z-index: 1;
}
.ai-home-section-part-title-inner:after {
  content: '';
  position: absolute;
  left: -20px;
  right: -20px;
  top: 50%;
  margin-top: -1px;
  height: 2px;
  background: #000;
  z-index: 0;
}
.ai-home-section-part-subtitle {
  margin-top: 20px;
  text-align: center;
  font-size: 16px;
  color: #666;
}
.ai-home-section-part-subtitle a {
  color: #1a73e8;
}
.ai-home-section-news {
  padding: 44px 0 60px;
  background: #fff;
}
.ai-home-section-technique {
  /* height: 870px; */
  padding: 100px 0 0;
  background: white;
}
.ai-home-section-technique .ai-tabs {
  margin-top: 60px;
  margin-bottom: 60px;
}
.ai-home-section-technique .ai-home-section-more {
  margin-top: unset;
  padding-top: 25px;
}
.ai-home-section-technique .ai-home-section-more-link {
  font-size: 16px;
}
.ai-home-section-technique .ai-home-section-more-link:hover {
  color: #1a73e8;
}
.ai-home-section-platform {
  position: relative;
  padding: 100px 0 120px;
  color: #2c3e50;
  background: rbg(245, 245, 245);
  -moz-background-size: 100% 100%;
  background-size: 100% 100%;
}
.ai-home-section-platform .square-dot-icon {
  position: absolute;
  right: 0;
  top: 0;
  width: 197px;
  height: 202px;
}
.ai-home-section-platform .rect-dot-icon {
  position: absolute;
  bottom: 8px;
  left: 35px;
  width: 237px;
  height: 50px;
}
.ai-home-section-platform .ai-layout-a {
  margin-top: 56px;
  color: #fff;
}
.ai-home-section-platform .ai-layout-a-item {
  width: 100%;
  margin-top: 20px;
  padding: 46px 15px 46px;
  border: 2px solid transparent;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  cursor: pointer;
  background: #4889f4;
  height: 240px;
}
@media screen and (max-width: 400px) {
  .ai-home-section-platform .ai-layout-a-item {
    width: 100%;
    margin-top: 20px;
    padding: 46px 15px 46px;
    border: 2px solid transparent;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    cursor: pointer;
    background: #4889f4;
    height: auto;
  }
}
.ai-home-section-platform .ai-layout-a-item-title {
  font-size: 22px;
  line-height: 26px;
  text-align: left;
}
.ai-home-section-platform .ai-layout-a-item-desc {
  margin-top: 28px;
  line-height: 24px;
  text-align: left;
}
.ai-home-section-platform .ai-layout-a-item-links {
  position: absolute;
  left: 50px;
  bottom: 50px;
}
.ai-home-section-platform .ai-layout-a-item:hover {
  border-color: #fff;
}
.ai-home-section-training {
  padding: 100px 0 50px;
}
.ai-home-section-training .ai-layout-a {
  margin-top: 56px;
  color: #000;
}
.ai-home-section-training .ai-layout-a-item {
  width: 280px;
  margin-top: 20px;
  padding: 68px 30px 104px;
  border: 1px solid #dadcdf;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  -moz-background-size: 100% 100%;
  background-size: 100% 100%;
  cursor: pointer;
}
.ai-home-section-training .ai-layout-a-item-title {
  font-size: 24px;
  font-weight: 700;
  line-height: 26px;
}
.ai-home-section-training .ai-layout-a-item-desc {
  margin-top: 28px;
  line-height: 24px;
}
.ai-home-section-training .ai-layout-a-item-links {
  position: absolute;
  left: 30px;
  bottom: 60px;
}
.ai-home-section-training .ai-layout-a-item:hover {
  -webkit-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
}
.ai-home-section-training .ai-layout-a-item:hover .ai-layout-a-item-links {
  color: #1a73e8;
}
.ai-home-section-training .ai-layout-a-item:first-child {
  background-image: url(//aip.bdstatic.com/portal-pc-node/dist/1579591791591/images/home/training/1.png);
}
.ai-home-section-training .ai-layout-a-item:nth-child(2) {
  background-image: url(//aip.bdstatic.com/portal-pc-node/dist/1579591791591/images/home/training/2.png);
}
.ai-home-section-training .ai-layout-a-item:nth-child(3) {
  background-image: url(//aip.bdstatic.com/portal-pc-node/dist/1579591791591/images/home/training/3.png);
}
.ai-home-section-training .ai-layout-a-item:nth-child(4) {
  background-image: url(//aip.bdstatic.com/portal-pc-node/dist/1579591791591/images/home/training/4.png);
}
.ai-home-section-industry {
  padding-top: 64px;
  padding-bottom: 64px;
  background: rgb(245, 245, 245);
}
.ai-home-section-industry .ai-layout-b {
  margin-top: 56px;
}
.ai-home-section-industry .ai-layout-b-item {
  width: 100%;
  height: auto;
  padding: 25px 10px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 400px) {
  .ai-home-section-industry .ai-layout-b-item {
    height: 220px;
  }
}
.ai-home-section-industry .ai-layout-b-item:hover {
  color: #1a73e8;
  -webkit-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
}
.ai-home-section-industry .ai-layout-b-item:hover .ai-layout-b-item-title {
  /* font-weight: 700; */
}
.ai-home-section-industry .ai-home-section-more-link {
  font-size: 16px;
}
.ai-home-section-industry .ai-home-section-more-link:hover {
  color: #1a73e8;
}
.ai-home-section-ecosystem {
  padding: 120px 0;
}
.ai-home-section-ecosystem .ai-layout-a {
  margin-top: 40px;
  color: #000;
}
.ai-home-section-ecosystem .ai-layout-a-item {
  width: 380px;
  border: 1px solid #dadcdf;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
}
.ai-home-section-ecosystem .ai-layout-a-item-bg {
  height: 218px;
  -moz-background-size: cover;
  background-size: cover;
}
.ai-home-section-ecosystem .ai-layout-a-item-inner {
  padding: 40px 50px;
}
.ai-home-section-ecosystem .ai-layout-a-item-title {
  font-size: 24px;
  line-height: 24px;
  font-weight: 700;
}
.ai-home-section-ecosystem .ai-layout-a-item-desc {
  height: 48px;
  margin-top: 24px;
  line-height: 24px;
  font-size: 14px;
  overflow: hidden;
}
.ai-home-section-ecosystem .ai-layout-a-item-links {
  height: 20px;
  margin-top: 24px;
}
.ai-home-section-ecosystem .ai-layout-a-item:hover {
  -webkit-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
}
.ai-home-section-ecosystem .ai-layout-a-item:hover .ai-layout-a-item-links {
  color: #1a73e8;
}
.ai-home-section-ecosystem .ai-layout-b {
  margin-top: 40px;
}
.ai-home-section-ecosystem .ai-layout-b-item:hover {
  color: #1a73e8;
  -webkit-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
}
.ai-home-section-ecosystem .ai-layout-b-item-title {
  margin-top: 40px;
  font-size: 14px;
}
.ai-home-section-ecosystem .ai-layout-b-item-img {
  width: 140px;
  height: 140px;
}
.ai-home-section-ecosystem .ai-home-section-more-link:hover {
  color: #1a73e8;
}
.ai-home-section-logos {
  height: 852px;
  padding: 100px 0 80px;
  background: #f9f9f9;
}
.ai-home-section-logos .ai-platform-wrap {
  width: 1200px;
}
.ai-home-section-logos .ai-tabs {
  margin-top: 40px;
  height: 588px;
  overflow: hidden;
}
.ai-home-section-logos .ai-tabs-header {
  position: relative;
}
.ai-home-section-logos .ai-tabs-header-line {
  position: absolute;
  -webkit-transition: -webkit-transform 0.8s ease;
  transition: -webkit-transform 0.8s ease;
  -moz-transition: transform 0.8s ease, -moz-transform 0.8s ease;
  transition: transform 0.8s ease;
  transition: transform 0.8s ease, -webkit-transform 0.8s ease,
    -moz-transform 0.8s ease;
  background-color: #000;
  z-index: 1;
}
.ai-home-section-logos .ai-tabs-pane {
  width: 100%;
  margin: 0 auto;
}
.ai-home-section-logos .fadeIn-leave {
  opacity: 1;
}
.ai-home-section-logos .fadeIn-leave-active {
  -webkit-transition: opacity 0.3s ease;
  -moz-transition: opacity 0.3s ease;
  transition: opacity 0.3s ease;
}
.ai-home-section-logos .fadeIn-enter,
.ai-home-section-logos .fadeIn-leave-to {
  opacity: 0;
}
.ai-home-section-logos .fadeIn-enter-active {
  -webkit-transition: opacity 0.3s ease;
  -moz-transition: opacity 0.3s ease;
  transition: opacity 0.3s ease;
}
.ai-home-section-logos .fadeIn-enter-to {
  opacity: 1;
}
.ai-home-section-logos .ai-home-section-more {
  margin-top: 60px;
}
.ai-home-section-logos .ai-home-section-more-link {
  display: inline-block;
  width: 150px;
  height: 48px;
  line-height: 48px;
  border: 2px solid #000;
  -webkit-border-radius: 33px;
  -moz-border-radius: 33px;
  border-radius: 33px;
  font-size: 20px;
  color: #000;
}
.ai-home-section-logos .ai-home-section-more-link:hover {
  background: #000;
  color: #fff;
}
.ai-home-section-brain {
  padding: 120px 0;
}
.ai-home-section-brain .ai-layout-a {
  margin-top: 80px;
  color: #000;
}
.ai-home-section-brain .ai-layout-a-item {
  width: 380px;
  padding: 60px 0 40px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  cursor: pointer;
}
.ai-home-section-brain .ai-layout-a-item-bg {
  height: 124px;
  -moz-background-size: contain;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50%;
}
.ai-home-section-brain .ai-layout-a-item-inner {
  padding: 0 50px;
}
.ai-home-section-brain .ai-layout-a-item-desc {
  height: 96px;
  margin-top: 40px;
  line-height: 24px;
  overflow: hidden;
  font-size: 14px;
}
.ai-home-section-brain .ai-layout-a-item:hover {
  background: #f9f9f9;
}
.casegray {
  background: rgb(245, 245, 245);
}
.casegray .col-6 {
  padding: 0 8px;
  margin: 0;
}
.casegray .case-list a {
  text-decoration: none;
  display: inline-block;
  width: 100%;
  margin: 30px 0 0 0;
  -webkit-filter: grey;
  filter: gray;
  padding: 6px 0px;
  background: white;
  border-radius: 6px !important;
  display: block;
}
.casegray img {
  width: 120px;
  /* height: 100px; */
}
.casegray .special img {
}
@media screen and (max-width: 400px) {
  .casegray img {
    width: 120px;
    /* height: 100px; */
  }
  .casegray .special img {
  }
}
.ai-home-section-strength {
  padding: 100px 0 80px;
  background: url(//aip.bdstatic.com/portal-pc-node/dist/1579591791591/images/home/map.jpg)
    no-repeat 50%;
  -moz-background-size: cover;
  background-size: cover;
}
.ai-home-section-strength .ai-home-section-more {
  margin-top: 110px;
}
.ai-home-section-strength .ai-home-section-more-link {
  display: inline-block;
  width: 150px;
  height: 48px;
  line-height: 48px;
  border: 2px solid #000;
  -webkit-border-radius: 33px;
  -moz-border-radius: 33px;
  border-radius: 33px;
  font-size: 20px;
  color: #000;
}
.ai-home-section-strength .ai-home-section-more-link:hover {
  background: #000;
  color: #fff;
}
.ai-home-propaganda {
  width: 100%;
  margin: 64px auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  text-align: center;
}
.ai-home-propaganda-item {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.ai-home-propaganda-item:last-child .ai-home-propaganda-unit {
  font-size: 36px;
}
.ai-home-propaganda-value {
  font-weight: 540;
}
.ai-home-propaganda-num {
  font-size: 70px;
  color: #080808;
}
.ai-home-propaganda-unit {
  margin-left: 5px;
  font-size: 24px;
}
.ai-home-propaganda-desc {
  margin-top: 16px;
  font-size: 24px;
}
.ai-home-logo {
  display: block;
  width: 220px;
  height: 90px;
  margin-top: 20px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.ai-home-logo:hover {
  -webkit-box-shadow: 0 1px 6px 0 hsla(0, 0%, 62.7%, 0.3);
  -moz-box-shadow: 0 1px 6px 0 hsla(0, 0%, 62.7%, 0.3);
  box-shadow: 0 1px 6px 0 hsla(0, 0%, 62.7%, 0.3);
}
.ai-home-logo img {
  display: block;
  width: 100%;
  height: 100%;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  border: 0;
}
.ai-home-logo-wall {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -moz-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.row {
  width: 100%;
  margin: 0;
}
.ai-technique-activities {
  /* height: 166px; */
  margin-left: -20px;
}
.ai-technique-activity {
  width: 100%;
  height: 100%;
  float: left;
  /* margin-left: 20px; */
  padding: 26px 30px 20px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -moz-background-size: cover;
  background-size: cover;
  background-position: 100% 100%;
  background-repeat: no-repeat;
}
.ai-technique-activity-title {
  font-size: 20px;
}
.ai-technique-activity-desc {
  margin-top: 12px;
}
.ai-technique-activity-price {
  padding-top: 11px;
}
.ai-technique-products {
  margin-top: 25px;
  display: block;
  zoom: 1;
}
.ai-technique-products:after {
  content: '';
  display: block;
  font-style: 0;
  height: 0;
  clear: both;
  visibility: hidden;
}
.ai-technique-product {
  float: left;
  width: 100%;
  height: 100%;
  padding: 15px 35px 13px 30px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin-bottom: 12px;
}
.ai-technique-product-title {
  font-size: 16px;
}
.ai-technique-product-desc {
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
  line-height: 20px;
  margin-top: 8px;
  text-align: left;
}
.ai-technique-product-price {
  padding-top: 8px;
}
.ai-technique-card {
  cursor: pointer;
}
.ai-technique-card-title {
  color: #000;
  font-weight: 700;
  position: relative;
  line-height: 1.5;
}
.ai-technique-card-desc {
  color: #666;
  font-size: 14px;
  line-height: 22px;
}
.ai-technique-card:hover {
  -webkit-box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05);
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  background-color: #fff;
}
.ai-technique-card:hover .ai-technique-card-title {
  color: #1a73e8;
}
.ai-technique-tag {
  font-size: 12px;
  color: #fff;
  background-image: -webkit-linear-gradient(225deg, #ff7138, #f24709);
  background-image: -moz-linear-gradient(225deg, #ff7138 0, #f24709 100%);
  background-image: linear-gradient(225deg, #ff7138, #f24709);
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
  line-height: 20px;
  position: absolute;
  top: 50%;
  margin-left: 10px;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  padding: 0 6px;
}
.ai-technique-activity-price-currency,
.ai-technique-activity-price-num,
.ai-technique-product-price-currency,
.ai-technique-product-price-num {
  font-size: 16px;
  color: #ff3813;
  line-height: 1.5;
}
.ai-technique-activity-price-unit,
.ai-technique-product-price-unit {
  color: #666;
  font-size: 14px;
}

.case {
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
  padding: 64px 0;
  overflow: hidden;
  color: black;
  text-align: center;
  /* height: 548px; */
}
/* .case.case1 {
  background-image: url(img/case-bg-ai-c033eba4ae.jpg);
}
.case.case2 {
  background-image: url(img/case-bg-yun-c4944f458d.jpg);
}
.case.case3 {
  background-image: url(img/case-bg-yt-862ea9851f.jpg);
}
.case.case4 {
  background-image: url(img/case-bg-wx-ddef20ad02.jpg);
}
.case.case5 {
  background-image: url(img/case-bg-ptu-0597390e7b.jpg);
}
.case.case6 {
  background-image: url(img/case-bg-yyb-5b258275c7.jpg);
}
.case.case7 {
  background-image: url(img/case-bg-qq-ab8216fdd5.jpg);
}
.case.case8 {
  background-image: url(img/case-bg-wps-bfe7cdda0e.jpg);
}
.case.case9 {
  background-image: url(img/case-bg-map-2560afeda4.jpg);
}
.case.case10 {
  background-image: url(img/case-bg-wb-648174131f.jpg);
}
.case.case11 {
  background-image: url(img/case-bg-qzone-76aa1e33b9.jpg);
}
.case.case12 {
  background-image: url(img/case-bg-dd-0a59e7be76.jpg);
}
.case.case13 {
  background-image: url(img/case-bg-nw-2295061c68.jpg);
}
.case.case14 {
  background-image: url(img/case-bg-kb-d592a6d38c.jpg);
}
.case.case15 {
  background-image: url(img/case-bg-wy-3801450b89.jpg);
}
.case.case16 {
  background-image: url(img/case-bg-music-4e70ced67d.jpg);
}
.case.case17 {
  background-image: url(img/case-bg-video-de09ffb652.jpg);
}
.case.case18 {
  background-image: url(img/case-bg-zl-7943332f04.jpg);
} */
.case h1 {
  font-size: 34px;
  line-height: 44px;
  text-align: center;
  color: inherit;
  font-weight: 400;
  color: #2c3e50;
}
.case-list {
  /* font-size: ; */
}
.tabimg {
  width: 120px;
  height: 120px;
  margin-bottom: 20px;
}
@media screen and (max-width: 400px) {
  .tabimg {
    width: 120px;
    height: 120px;
    margin-bottom: 20px;
  }
}
.case-list a {
  text-decoration: none;
  display: inline-block;
  width: 100%;
  line-height: 100px;
  /* height: 110px; */
  margin: 30px 0 0 0;
  -webkit-filter: grey;
  filter: gray;
  padding: 5px 0px;
  background: white;
  border-radius: 10px !important;
  display: block;
}
.case-list a.active,
.case-list a:hover {
  -webkit-filter: grayscale(0);
  -moz-filter: grayscale(0);
  -ms-filter: grayscale(0);
  -o-filter: grayscale(0);
  filter: grayscale(0);
  -webkit-filter: none;
  filter: none;
}
/* .case .ico-1 {
  margin-left: 0;
  background-image: url(../../sprite/sprite-814a811252.index.v2.png?max_age=31536000);
  background-position: -545px -208px;
}
.case .ico-2 {
  background-image: url(../../sprite/sprite-814a811252.index.v2.png?max_age=31536000);
  background-position: -545px -104px;
}
.case .ico-3 {
  background-image: url(../../sprite/sprite-814a811252.index.v2.png?max_age=31536000);
  background-position: -545px 0;
}
.case .ico-4 {
  background-image: url(../../sprite/sprite-814a811252.index.v2.png?max_age=31536000);
  background-position: -302px -372px;
}
.case .ico-5 {
  background-image: url(../../sprite/sprite-814a811252.index.v2.png?max_age=31536000);
  background-position: -151px -476px;
}
.case .ico-6 {
  background-image: url(../../sprite/sprite-814a811252.index.v2.png?max_age=31536000);
  background-position: 0 -372px;
}
.case .ico-7 {
  margin-left: 0;
  background-image: url(../../sprite/sprite-814a811252.index.v2.png?max_age=31536000);
  background-position: -394px -208px;
}
.case .ico-8 {
  background-image: url(../../sprite/sprite-814a811252.index.v2.png?max_age=31536000);
  background-position: -394px -104px;
}
.case .ico-9 {
  background-image: url(../../sprite/sprite-814a811252.index.v2.png?max_age=31536000);
  background-position: -394px 0;
}
.case .ico-10 {
  background-image: url(../../sprite/sprite-814a811252.index.v2.png?max_age=31536000);
  background-position: 0 -476px;
}
.case .ico-11 {
  background-image: url(../../sprite/sprite-814a811252.index.v2.png?max_age=31536000);
  background-position: -151px -372px;
}
.case .ico-12 {
  background-image: url(../../sprite/sprite-814a811252.index.v2.png?max_age=31536000);
  background-position: -545px -312px;
}
.case .ico-13 {
  margin-left: 0;
  background-image: url(../../sprite/sprite-2a0a82c8f6.index.png?max_age=31536000);
  background-position: 0 -396px;
}
.case .ico-14 {
  background-image: url(../../sprite/sprite-2a0a82c8f6.index.png?max_age=31536000);
  background-position: -151px -396px;
}
.case .ico-15 {
  background-image: url(../../sprite/sprite-2a0a82c8f6.index.png?max_age=31536000);
  background-position: -302px -396px;
}
.case .ico-16 {
  background-image: url(../../sprite/sprite-2a0a82c8f6.index.png?max_age=31536000);
  background-position: -584px 0;
}
.case .ico-17 {
  background-image: url(../../sprite/sprite-2a0a82c8f6.index.png?max_age=31536000);
  background-position: -584px -104px;
}
.case .ico-18 {
  background-image: url(../../sprite/sprite-2a0a82c8f6.index.png?max_age=31536000);
  background-position: -584px -208px;
} */
@media screen and (max-width: 800px) {
  .w-100 {
    max-width: unset;
    width: auto !important;
  }
}

@media screen and (max-width: 400px) {
  .ai-tabs-header:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    top: 92px;
    bottom: 0;
    left: 0px;
    background: #dadcdf;
  }
  .ai-tabs-item-active::after {
    display: block;
    content: '';
    width: 50%;
    left: 50%;
    height: 5px;
    position: absolute;
    top: 90px;
    left: 50%;
    background-color: #000;
    transform: translateX(-50%);
    z-index: 99;
  }
}
.rt60 {
  position: relative;
  top: -60px;
  margin-bottom: -60px;
}
.mytabclass,
.mypclass {
  height: 100%;
}
.mytabclass .mypclass .mydetail {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.specialH3 {
  width: 100%;
  background: skyblue;
  padding: 20px;
  font-size: 20px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  flex-wrap: wrap;
  color: white;
  text-align: center;
}
.specialPA {
  width: 100%;
  display: flex;
  /* justify-content: space-around; */
  /* align-items: center; */
  justify-content: space-around;
  flex-wrap: wrap;
  align-items: center;
  /* height: 300px; */
  padding: 20px 0px;
}
.specialP {
  width: 40%;
  text-align: center !important;
  background: #f3f0f0;
  padding: 20px 0px;
  font-family: '黑体';
  font-size: 16px;
}
.specialBC {
  background-color: white;
}
.scene-item {
  box-sizing: border-box;
  /* width: 386px; */
  float: left;
  background-color: #fff;
  margin-bottom: 20px;
  margin-left: 20px;
  transition: all 0.3s ease;
  list-style: none;
}
.scene-item-img {
  position: relative;
  overflow: hidden;
  line-height: 1;
}
.scene-item-img img {
  display: block;
  width: 100% !important;
  height: 100% !important;
  transition: -webkit-transform 0.3s ease;
  transition: transform 0.3s ease;
  transition: transform 0.3s ease, -webkit-transform 0.3s ease;
  -webkit-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
}
.scene-item-img:hover img {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.scene-item-img h5 {
  font-size: 20px;
  color: #fff;
  position: absolute;
  bottom: 50px;
  left: 26px;
  letter-spacing: 5px;
}
.scene-item-img p {
  color: #87898e;
  font-size: 20px;
  position: absolute;
  bottom: 20px;
  left: 26px;
  font-family: arial;
}
.scene-item-des {
  width: 100%;
  position: relative;
  padding: 16px 8px 16px 20px;
  text-align: left;
  height: 160px;
}
.mobile {
  width: auto !important;
  max-width: 100%;
  height: 100% !important;
}
@media screen and (max-width: 480px) {
  .scene-item-des {
    height: auto;
  }
  .mobile {
    width: auto !important;
    max-width: none !important;
    height: 100% !important;
  }
}
.scene-item:hover {
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
}
.logo-1:after {
  background-image: url('../../img/sprite-9ba2e7adb2.case.hardware.png');
  background-position: 0 -570px;
}
.logo-2:after {
  background-image: url('../../img/sprite-9ba2e7adb2.case.hardware.png');
  background-position: -460px -570px;
}
.logo-3:after {
  background-image: url('../../img/sprite-9ba2e7adb2.case.hardware.png');
  background-position: -345px -570px;
}
.scene-item-des:after {
  content: '';
  width: 111px;
  height: 111px;
  display: inline-block;
  position: absolute;
  top: -86px;
  right: 0px;
}
.bcw {
  background: white;
  position: relative;
}
.specialBC {
  background: whitesmoke;
  color: white;
}
.specialP {
  color: black;
  background-color: white;
}
.compose-content-else {
  color: black;
}
.compose-content-else:before {
  content: '';
  background-image: url('../../img/sprite-9ba2e7adb2.case.hardware.png');
  background-position: -711px -570px;
  display: inline-block;
  vertical-align: middle;
  width: 64px;
  height: 64px;
  margin-right: 13px;
}
.img100 {
  width: 100%;
}
.bg100 {
  // background-size: 100% 100% !important;
  // background-repeat: no-repeat;
  // height: 250px;
  width: 100%;
}
.example-3d {
  width: 100%;
  height: 310px;
  padding-top: 0px;
  padding-bottom: 50px;
}

.example-3d {
  width: 100%;
  height: 310px;
  padding-top: 0px;
  padding-bottom: 50px;
}

.swiper {
  height: 100%;
  width: 100%;
  padding: 20px 100px 60px;

  .swiper-slide {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 300px;
    // height: 300px;
    text-align: center;
    font-weight: bold;
    // font-size: $font-size-huge * 2;
    background-color: #2c8dfb;
    background: whitesmoke;
    background-position: center;
    background-size: cover;
    color: #333;
  }

  h3 {
    font-size: 22px;
    margin-top: 12px;
    margin-bottom: 12px;
    font-weight: normal;
    // border-bottom: 1px solid #333;
    padding-bottom: 6px;
  }

  p {
    font-size: 16px;
    font-weight: normal;
    text-align: left;
    color: #808080;
  }

  .swiper-pagination {
    /deep/ .swiper-pagination-bullet.swiper-pagination-bullet-active {
      background-color: #666;
    }
  }
}
.h650 {
  height: 650px;
  overflow: hidden;
}
.poL {
  position: absolute;
  width: 100%;
  bottom: 0px;
  left: 10px;
  text-align: left;
  color: white;
}
.poL h3 {
  margin-bottom: 20px;
  font-size: 24px;
}
.poR {
  position: absolute;
  width: 100%;
  bottom: 0px;
  left: 10px;
  text-align: left;
  color: white;
}
.poR h3 {
  margin-bottom: 20px;
  font-size: 24px;
}
.poA {
  position: absolute;
  top: 235px;
  left: 260px;
  text-align: left;
  /* background: white; */
  color: white;
}
.poA h3 {
  font-size: 30px;
  margin-bottom: 1rem;
}
.poA p {
  font-size: 22px;
}
@media screen and (max-width: 1366px) {
  .mainTop {
    height: 440px;
  }
}
@media screen and (max-width: 480px) {
  .swiper {
    padding: 0 0 20px;
  }
  .mainTop {
    height: 650px;
  }
  .poA {
    position: absolute;
    top: 235px;
    left: 83px;
    text-align: left;
    /* background: white; */
    color: white;
    width: 65%;
  }
  //   .poL {
  //     position: absolute;
  //     top: 24%;
  //     left: 15%;
  //     text-align: left;
  //     width: 35%;
  //   }
  //   .poL h3 {
  //     margin-bottom: 10px;
  //     font-size: 12px;
  //   }
  //   .poL p {
  //     font-size: 10px;
  //     margin-bottom: 6px;
  //   }
  //   .poR h3 {
  //     margin-bottom: 10px;
  //     font-size: 12px;
  //   }
  //   .poR p {
  //     font-size: 10px;
  //     margin-bottom: 6px;
  //   }
}
.swiper-button-prev,
.swiper-button-next {
  width: 50px;
  height: 50px;
  color: #333;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 24px;
  width: 50px;
  height: 50px;
  display: block;
  padding-top: 11px;
  padding-left: 0px;
  border: 1px solid #333;
  border-radius: 50%;
}
.solutionDitails .block {
  width: 100%;
}
.solutionDitails .block img {
  width: 100%;
  height: 230px;
}
.solutionDitails .block h4 {
  font-size: 22px;
  // font-weight: ;
}
.solutionDitails .block p {
  font-size: 16px;
  color: #999;
}
.pb0 {
  padding-bottom: 0;
}
.mypointer {
  cursor: pointer;
  overflow: hidden;
}
.mypointer h3 {
  transition: 0.4s;
}
.mypointer img {
  transition: 0.6s;
}
.mypointer:hover img {
  transform: scale(1.1);
}
.mypointer:before {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: '';
  /* transition: opacity 5s cubic-bezier(.23,1,.32,1),height 5s cubic-bezier(.23,1,.32,1); */
  opacity: 0;
  transition: 0.6s;
  background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2));
}
.mypointer:hover:before {
  opacity: 1;
}
.mypointer:hover h3 {
  transform: translateY(-30px);
}
.pb130 {
  padding-bottom: 130px;
}
.pb0 {
  padding-bottom: 0;
}
.topChange {
  display: flex;
  width: 375px;
  margin: 0 auto;
  position: absolute;
  top: -66px;
  left: 50%;
  transform: translate(-50%, 0);
  height: 66px;
  line-height: 66px;
}
.topChange li {
  padding: 0 20px;
  font-size: 20px;
  color: white;
  cursor: pointer;
}
.topChange li.active {
  background: white;
  color: #0067ed;
}
.img-block {
  width: 85%;
}
.advantage-show {
  height: 480px;
  background: url(../../public/img/Solution/line_dot-3f88c.png) no-repeat 50%;
  background-size: contain;
  position: relative;
  transition: all 0.3s;
}
.aos-animate {
  opacity: 1;
  transform: scale(1);
}
.advantage-box {
  height: 170px;
  background: #fff;
  border-radius: 4px;
  text-align: center;
  margin-bottom: 20px;
  transition: all 0.5s;
}
.advantage-show li p {
  background: #fff;
  padding: 8px 20px;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) scale(0);
  margin: 0;
  white-space: nowrap;
  border-radius: 4px;
  box-shadow: 0 0 15px 0 rgba(5, 5, 5, 0.3);
  font-size: 14px;
  transition: all 0.5s;
}
.advantage-show li span {
  position: absolute;
  left: -14px;
  top: -14px;
  display: block;
  width: 28px;
  height: 28px;
  line-height: 28px;
  font-size: 20px;
  text-align: center;
  //   background: #0067ed;
  color: #fff;
  border-radius: 100%;
}

.advantage-show li {
  position: absolute;
  border-radius: 100%;
  display: block;
  background: #000;
  transition: all 0.5s;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  box-shadow: 0 5px 32px 0 hsla(0, 0%, 53.3%, 0.24);
}
.advantage-show li p.aos-animate {
  transform: translateX(-50%) scale(1);
}

.advantage-show .one {
  width: 210px;
  height: 210px;
  left: 40%;
  top: 30%;
}
.advantage-show .two {
  width: 150px;
  height: 150px;
  left: 15%;
  top: 25%;
  -webkit-animation-delay: 0.5s;
  animation-delay: 0.5s;
}
.advantage-show .three {
  width: 135px;
  height: 135px;
  right: 16%;
  top: 5%;
  -webkit-animation-delay: 0.8s;
  animation-delay: 0.8s;
}
.advantage-show .four {
  width: 120px;
  height: 120px;
  left: 19%;
  bottom: 10%;
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}
.advantage-show .five {
  width: 100px;
  height: 100px;
  right: 10%;
  bottom: 20%;
  -webkit-animation-delay: 0.5s;
  animation-delay: 0.5s;
}
.advantage-show .six {
  width: 70px;
  height: 70px;
  left: 40%;
  top: 15%;
  -webkit-animation-delay: 0.8s;
  animation-delay: 0.8s;
}
.advantage-show .seven {
  width: 60px;
  height: 60px;
  right: 13%;
  top: 40%;
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}
.advantage-show .eight {
  width: 40px;
  height: 40px;
  right: 30%;
  bottom: 7%;
  -webkit-animation-delay: 1s;
  animation-delay: 1s;
}
.advantage-show .one p {
  font-size: 18px;
}
.upDown {
  -webkit-animation-name: upDown;
  animation-name: upDown;
  -webkit-animation-duration: 5s;
  animation-duration: 5s;
}
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
.f70 {
  display: inline-block;
  color: #0067ed;
  line-height: 1;
  margin: 40px 0 20px;
  font-size: 60px;
}
.p16 {
  font-size: 16px;
  font-weight: 300;
}
@media screen and (max-width: 480px) {
  .advantage-show .one {
    width: 10.5rem;
    height: 10.5rem;
    left: 26%;
    top: 33%;
  }
  .advantage-show .two {
    width: 6.6rem;
    height: 6.6rem;
    left: 9%;
    top: 11%;
  }
  .advantage-show .three {
    width: 5.3rem;
    height: 5.3rem;
    right: 12%;
    top: 15%;
  }
  .advantage-show .four {
    width: 7rem;
    height: 7rem;
    left: 14%;
    bottom: 1%;
  }
  .advantage-show .five {
    width: 5.8rem;
    height: 5.8rem;
    right: 3%;
    bottom: 17%;
  }
  .advantage-show .six {
    width: 70px;
    height: 70px;
    left: 40%;
    top: 15%;
    -webkit-animation-delay: 0.8s;
    animation-delay: 0.8s;
  }
  .advantage-show .seven {
    width: 60px;
    height: 60px;
    right: 13%;
    top: 40%;
    -webkit-animation-delay: 0.3s;
    animation-delay: 0.3s;
  }
  .advantage-show .eight {
    width: 40px;
    height: 40px;
    right: 30%;
    bottom: 7%;
    -webkit-animation-delay: 1s;
    animation-delay: 1s;
  }
  .txtbox {
    padding: 20px 20px;
  }
  .img-block {
    width: 100%;
  }
}
.plus-icon-enter-active {
  transition: opacity 0.5s;
}
.plus-icon-enter {
  opacity: 0;
}
.plus-icon-leave-active {
  transition: opacity 0s;
}
.plus-icon-leave-to {
  opacity: 0;
}
p {
  margin-bottom: 11px;
}
</style>
